import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MaskPipe } from 'ngx-mask';
import { permission } from 'src/app/data/permissions';
import Utils from 'src/app/helpers/utils';

import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ApprovalService } from 'src/app/services/approval/approval.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-dashboard-approval',
  templateUrl: './dashboard-approval.component.html',
  styleUrls: ['./dashboard-approval.component.scss'],
})
export class DashboardApprovalComponent implements OnInit, OnDestroy {
  @ViewChild('toggleVersions') toggleVersions: ElementRef;
  @ViewChild('toggleLeftVersions') toggleLeftVersions: ElementRef;
  @ViewChild('toggleRightVersions') toggleRightVersions: ElementRef;
  @ViewChild('toggleVersionSelector') toggleVersionSelector: ElementRef;
  @ViewChild('approveButtonDropdown') approveButtonDropdown: ElementRef;
  @ViewChild('approveButtonDropdownNoTooltip')
  approveButtonDropdownNoTooltip: ElementRef;
  @ViewChild('tabsWrapper') tabsWrapper: ElementRef;
  @ViewChild('tabsContainer') tabsContainer: ElementRef;
  @ViewChild('editRoleButtonDropdown') editRoleButtonDropdown: ElementRef;
  @ViewChild('editRoleButtonDropdownNoTooltip')
  editRoleButtonDropdownNoTooltip: ElementRef;

  reproveForm = this.formBuilder.group({
    description: [null, [Validators.required]],
  });

  homologateForm = this.formBuilder.group({
    reason: [null, [Validators.required]],
  });

  /** Modal ativar/inativar papel (opção do dropdown Aprovar cadastro) */
  showPaperStatusModal = false;
  paperStatusSubmitting = false;
  selectedPaperRole: any = null;
  /** Lista estável de itens do select de papel (evita reset ao abrir dropdown). */
  paperRoleSelectItemsCache: { label: string; value: string | number }[] = [];
  private paperRoleSelectSub?: Subscription;
  /** Só o select quando há vários papéis (mesmo fluxo que dashboard-user-list). */
  paperStatusForm = this.formBuilder.group({
    role_control_id: [null as string | number | null],
  });

  /** Modal ativar/inativar cadastro (dropdown Aprovar cadastro) */
  showRegisterCadastroModal = false;
  registerCadastroStatusSubmitting = false;
  registerActivateAllPapers = false;
  registerActivatePaperSelectItems: { label: string; value: string }[] = [];
  registerActivatePapersForm = this.formBuilder.group({
    paperIds: [[] as string[]],
  });

  tabs: Tab[] = [];
  previousUrl: string = '';
  canScrollLeft = false;
  canScrollRight = false;

  status = [
    {
      department: 'Compliance',
      approved_datetime: '23/10/2021 às 16:32',
      completed: true,
    },
    {
      department: 'Cadastro',
      approved_datetime: null,
      completed: true,
    },
    {
      department: 'Diretoria',
      approved_datetime: null,
      completed: false,
    },
  ];

  permissionObj: PermissionValues = {
    canChange: false,
    canReject: false,
    canApprove: false,
    canReturn: false,
  };

  tabIndex = 0;
  activedTab = 'complementary';

  approval: UserApprovalResponse = null;
  approvalStepsTimeline: any[] = [];
  allApprovals: VersionProps[];

  /** Role-controls do EP (independente de getApproval). null = ainda não carregou. */
  roleControlsList: any[] | null = null;
  roleControlsLoading = false;

  cards: any = undefined;

  role = '';

  applicableRole = 'ADM';

  departmentAttemps = {};

  isSimplified = false;
  isFund = false;
  isOnlyRepresentative = false;
  hasRepresentativeRole = false;
  self_view = false;
  isRepresentativeViewer = false;
  representativeSignRequired = false;
  representativeHasSigned = false;
  representativeSignId: number | null = null;
  representativeSigning = false;
  private _signing = true;
  warningModal = false;

  // Getter e setter para signing com logging automático
  get signing(): boolean {
    return this._signing;
  }

  set signing(value: boolean) {
    if (this._signing !== value) {
      this._signing = value;
    }
  }
  approve = false;
  resetApproval = false;
  loading = true;
  showOptions = false;
  showCtaOptions = false;
  showVersionsOptions = false;
  comparingVersions = false;
  showLeftVersions = false;
  showRightVersions = false;
  selectedLeftVersion: VersionProps = null;
  selectedRightVersion: VersionProps = null;
  showVersionSelector = false;
  showVersionDropdown = false;
  loadingVersions = false;
  loadingLeftVersions = false;
  loadingRightVersions = false;
  loadingViewAllVersions = false;
  loadingHeaderVersion = false;
  selectedVersion: VersionProps = null;
  isApprover = false;
  loadingRepresentativeStep = false;
  confirmEditModal = true;
  userArea: string = null; // Área do usuário obtida da API

  validation_token = undefined;

  sign_view = undefined;

  private updateApprovalQueueSubscription: Subscription;

  register_id = null;
  homologated = false;
  hasDraft = false;
  hasRoleDraft: boolean = false;
  roleDraftInfo: any = null;
  loadingContinueRoleDraft: boolean = false;
  registrationExpired: boolean = false;
  registrationExpirationInfo: any = null;

  // Modal properties
  showValidationModal = false;
  showFileApprovalModal = false;
  showFileRejectionModal = false;
  showRepresentativeSignModal = false;
  showRepresentativeSignErrorModal = false;
  showFileApprovalSuccessModal = false;
  showFileApprovalErrorModal = false;
  showEditWarningModal = false;
  editingLoading = false;
  editingFullscreenLoading = false;
  currentAttachment: any = null;
  currentSituation: number = null;
  fileDescription: string = '';
  showEditRoleDropdown = false;
  selectedEditRole: any = null;

  // Versionamento properties
  versioningData: any = null;
  versioningIsComplete: boolean = true;
  versioningProgress: any = null;
  versioningInterval: any = null;
  reprocessSnapshotCalled: boolean = false; // Flag para controlar se já chamou a API de reprocess

  partners: PartnerResponse[] = [];
  formattedData: PartnerResponse[] = [];

  provider = {
    admin: null,
    manager: null,
  };

  legacyVersionChecked = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService,
    private api: ApiService,
    private authService: AuthService,
    private approvalService: ApprovalService,
    private formBuilder: FormBuilder,
    protected sanitizer: DomSanitizer,
    private maskPipe: MaskPipe,
    private storageService: StorageService,
    private renderer: Renderer2,
    private breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.toggleVersions?.nativeElement.contains(e.target)) {
        this.showVersionsOptions = false;
      }
      if (!this.toggleLeftVersions?.nativeElement.contains(e.target)) {
        this.showLeftVersions = false;
      }
      if (!this.toggleRightVersions?.nativeElement.contains(e.target)) {
        this.showRightVersions = false;
      }
      if (!this.toggleVersionSelector?.nativeElement.contains(e.target)) {
        this.showVersionDropdown = false;
      }
      // Verificar se o clique foi dentro do dropdown do botão de editar
      const target = e.target as HTMLElement;
      const clickedInEditRoleDropdown =
        (this.editRoleButtonDropdown?.nativeElement &&
          this.editRoleButtonDropdown.nativeElement.contains(target)) ||
        (this.editRoleButtonDropdownNoTooltip?.nativeElement &&
          this.editRoleButtonDropdownNoTooltip.nativeElement.contains(target));
      if (!clickedInEditRoleDropdown) {
        this.showEditRoleDropdown = false;
      }
      // Verificar se o clique foi dentro do dropdown do botão de aprovar
      const clickedInApproveDropdown =
        (this.approveButtonDropdown?.nativeElement &&
          this.approveButtonDropdown.nativeElement.contains(target)) ||
        (this.approveButtonDropdownNoTooltip?.nativeElement &&
          this.approveButtonDropdownNoTooltip.nativeElement.contains(target));
      if (!clickedInApproveDropdown) {
        this.showCtaOptions = false;
      }
    });
  }

  ngOnDestroy(): void {
    // Fazer unsubscribe do listener de atualização de queue
    if (this.updateApprovalQueueSubscription) {
      this.updateApprovalQueueSubscription.unsubscribe();
    }

    // Limpar intervalo de versionamento
    if (this.versioningInterval) {
      clearInterval(this.versioningInterval);
      this.versioningInterval = null;
    }

    this.approvalService.reset();
  }

  ngOnInit(): void {
    this.register_id = this.route.snapshot.params['id'];
    let range = this.router.url.split('/').length;
    this.role = this.router.url.split('/')[range - 2];

    // Permitir acesso para master e colaborador comum aos detalhes
    // Master já tem acesso automático, então só verifica se não for master nem colaborador comum

    /* get query params */
    this.route.queryParams.subscribe((params) => {
      if (params.sign_view) {
        this.sign_view = params.sign_view;
        this.showValidationModal = true;
      }
    });

    if (this.authService.token === undefined) {
      this.router.navigateByUrl(
        `/login/?role=${this.role}&id=${this.route.snapshot.params.id}`,
      );
    }

    this.route.params.subscribe((params) => {
      this.loading = true;
      this.signing = true;
      this.tabIndex = 0;
      this.activedTab = 'complementary';
      this.approvalService.reset();
      this.approvalService.approvalData.activeTab = 'complementary';
      this.register_id = params.id;
      this.roleControlsList = null;
      this.roleControlsLoading = true;

      // Resetar flag de legacy version quando mudar de cadastro
      this.legacyVersionChecked = false;

      // Resetar flag de reprocess quando mudar de cadastro
      this.reprocessSnapshotCalled = false;
      this.versioningIsComplete = true;
      this.versioningProgress = null;

      // Limpar intervalo anterior se existir
      if (this.versioningInterval) {
        clearInterval(this.versioningInterval);
        this.versioningInterval = null;
      }

      this.self_view = this.authService.user.active_register
        ? this.authService.user.active_register.register.id === params.id
        : false;

      this.authService.reloadComplementaryDataEvent.emit(params);

      // Não precisa mais chamar checkAndCreateLegacyVersion - o backend já cria versão 1 automaticamente
      // quando não existe versão 1, então não precisa mais chamar a API legacy
      this.getApproval();
      this.loadRoleControls();
      this.loadApprovalTimeline();
      // this.getRegistrationVersions(); // Comentado - as chamadas são feitas pelo componente dashboard-approval-complementary com last=true

      // Chamar API de versionamento quando a página carregar
      // this.loadVersioningData();
    });

    const hasApprovePermission = this.authService.verifyPermission(
      `de_can_approve_${this.role}`,
    );

    // Verificar se é owner ou master
    const permissionType = this.storageService.getPermissionType();
    const isOwnerOrMaster =
      permissionType === 'owner' || permissionType === 'master';

    this.isApprover =
      this.authService.user.is_superuser ||
      hasApprovePermission ||
      isOwnerOrMaster;

    this.setBreadcrumb();
    this.setPermissions();
    this.getSwitchMainAccount();

    // Buscar a área do usuário - aguardar para garantir que está carregada antes de qualquer verificação
    // Isso previne race conditions onde o botão pode ficar habilitado antes da área ser carregada
    this.getUserArea().catch((error) => {
      console.error(
        '[DashboardApproval] Erro ao carregar área do usuário:',
        error,
      );
    });

    // Escutar atualizações de queue e current_department da API v3
    this.updateApprovalQueueSubscription =
      this.approvalService.updateApprovalQueue.subscribe(
        (data: { queue?: any; current_department?: any }) => {
          if (this.approval) {
            // Atualizar queue se existir
            if (data.queue) {
              if (!this.approval.queue) {
                this.approval.queue = {} as any;
              }
              if (
                data.queue.departments &&
                Array.isArray(data.queue.departments)
              ) {
                this.approval.queue.departments = data.queue.departments;
              }
              if (data.queue.id !== undefined) {
                this.approval.queue.id = data.queue.id;
              }
            }

            // Atualizar current_department se existir
            if (data.current_department) {
              this.approval.current_department = {
                ...this.approval.current_department,
                ...data.current_department,
                department:
                  data.current_department.department ||
                  (data.current_department.name
                    ? { name: data.current_department.name }
                    : this.approval.current_department?.department),
              };
            }
          }
        },
      );
  }

  async getSwitchMainAccount() {
    try {
      const data = await this.api.get<any[]>({
        route: `api/v2/registration/account-switch/`,
        params: {
          type: 'profile',
        },
        token: true,
      });

      // Atualizar visible_accounts no authService se necessário
      if (data && data.length > 0) {
        const newData = data.sort((a, b) => b.id - a.id).reverse();
        this.authService.visible_accounts = newData;
      }
    } catch (error) {}
  }

  // Método comentado - as chamadas da API v3 com last=true são feitas pelo componente dashboard-approval-complementary
  // async getRegistrationVersions() {
  //   try {
  //     // Usa register_id que já foi atualizado ou pega da rota
  //     const register_uuid = this.register_id || this.route.snapshot.params['id'];
  //
  //     if (!register_uuid) {
  //       console.warn('Register UUID não encontrado na rota');
  //       return;
  //     }

  //     // Chamada com data_type=complementary

  //     const responseComplementary = await this.api.get({
  //       route: `api/v3/registration/versions/register/${register_uuid}/`,
  //       params: {
  //         data_type: 'complementary',
  //       },
  //       token: true,
  //     });

  //     // Chamada com data_type=address
  //     const responseAddress = await this.api.get({
  //       route: `api/v3/registration/versions/register/${register_uuid}/`,
  //       params: {
  //         data_type: 'address',
  //       },
  //       token: true,
  //     });

  //     // Por enquanto só faz o GET para ver a resposta
  //   } catch (error) {
  //     console.error('❌ Erro ao buscar versões do registro (v3):', error);
  //   }
  // }

  /**
   * Busca approval da API v3
   */
  async getApprovalFromV3(
    version: number = null,
  ): Promise<UserApprovalResponse | null> {
    try {
      const register_uuid = this.route.snapshot.params.id;

      if (!register_uuid) {
        return null;
      }

      const params: any = {
        data_type: 'complementary',
      };

      if (version) {
        params.version = version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        const mapped = this.mapV3ResponseToApproval(response);
        // Anexar timeline de steps de aprovação, se existir
        if (response.data.approval_steps_timeline) {
          (mapped as any).approval_steps_timeline =
            response.data.approval_steps_timeline;
        }
        return mapped;
      }

      return null;
    } catch (error) {
      console.error('[DashboardApproval] getApprovalFromV3 - ERRO:', error);
      throw error;
    }
  }

  /**
   * Papéis dos badges vêm de `register.papers` (v3) ou `register.role_controls` legado; sem EP role-controls.
   * Mantém roleControlsList em null para getRoleControlsForDisplay usar o register; só encerra o loading da UI.
   */
  async loadRoleControls(): Promise<void> {
    const register_uuid = this.register_id || this.route.snapshot.params?.id;
    if (!register_uuid) return;
    this.roleControlsLoading = true;
    this.roleControlsList = null;
    this.cdr.detectChanges();
    try {
      // Intencionalmente sem GET — o endpoint role-controls/ está descontinuado com erro em stage.
    } finally {
      this.roleControlsLoading = false;
      this.cdr.detectChanges();
    }
  }

  /** Mock da approval-timeline (20 itens): 3 cedente, 3 cotista, 3 prestador; reset e repete; completa com 2. */
  private static readonly APPROVAL_TIMELINE_MOCK: any[] = (() => {
    const base = '2026-01-26T12:00:00.000000+00:00';
    const steps = [
      { label: 'Edição', status: 'editing', order: 0 },
      { label: 'Consultor', status: 'approved', order: 1 },
      { label: 'Compliance', status: 'approved', order: 2 },
      { label: 'Cadastro', status: 'pending', order: 3 },
      { label: 'Homologado', status: 'approved', order: 4 },
    ];
    const roles = [
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'cotista', role_id: 2 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'prestador', role_id: 3 },
      { role_name: 'cedente', role_id: 1 },
      { role_name: 'cotista', role_id: 2 },
    ];
    return roles.map((role, i) => {
      // Últimos dois itens: Edição e Consultor (Consultor aprovado); demais seguem o ciclo
      const isLastTwo = i >= roles.length - 2;
      const s = isLastTwo
        ? i === roles.length - 2
          ? { label: 'Edição', status: 'editing', order: 0 }
          : { label: 'Consultor', status: 'approved', order: 1 }
        : steps[i % steps.length];
      const d = new Date(base);
      d.setMinutes(d.getMinutes() + i * 15);
      return {
        approval_id: 4000 + Math.floor(i / 5),
        version_number: 1 + Math.floor(i / 10),
        role_control_id: null,
        role_id: role.role_id,
        role_name: role.role_name,
        step_type: s.order === 0 ? 'editing' : 'approval_step',
        step_label: s.label,
        status: s.status,
        is_current: i === roles.length - 1,
        date: d.toISOString(),
        signed_by: s.status === 'approved' ? 'Usuário Aprovador' : null,
        description: null,
        step_order: s.order,
        step_index: i,
      };
    });
  })();

  /** Traduz role_name do back para exibição na timeline. */
  private mapTimelineRoleLabel(roleName: string): string {
    const r = (roleName ?? '').toString().toLowerCase();
    if (r.includes('cedente')) return 'Cedente';
    if (r.includes('cotista')) return 'Cotista';
    if (r.includes('prestador')) return 'Prestador de Serviço';
    return roleName || '—';
  }

  /**
   * Mapeia item do EP approval-timeline para o formato do componente de timeline.
   */
  private mapApprovalTimelineToSteps(raw: any[]): any[] {
    if (!Array.isArray(raw) || raw.length === 0) return [];
    return raw.map((item: any) => ({
      step_label: item.step_label ?? '—',
      order: item.step_index ?? item.step_order ?? 0,
      approval_id: item.approval_id,
      version_number: item.version_number,
      approved_at: item.date ?? item.approved_at,
      role_name: this.mapTimelineRoleLabel(item.role_name ?? ''),
      signed_by: item.signed_by ?? null,
      is_editing_step: (item.step_label ?? '')
        .toString()
        .toLowerCase()
        .includes('edição'),
    }));
  }

  /**
   * Busca approval-timeline do EP; em 404 usa mock e preenche approvalStepsTimeline.
   */
  async loadApprovalTimeline(): Promise<void> {
    const register_uuid = this.register_id || this.route.snapshot.params?.id;
    if (!register_uuid) return;
    console.log(
      '[DashboardApproval] approval-timeline - MOCK de referência (contrato desejado):',
      DashboardApprovalComponent.APPROVAL_TIMELINE_MOCK,
    );
    let data: any[] = [];
    try {
      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/approval-timeline/`,
        token: true,
      });
      const raw = Array.isArray(response)
        ? response
        : (response?.data ?? response?.results ?? []);
      data = raw.length
        ? raw
        : DashboardApprovalComponent.APPROVAL_TIMELINE_MOCK;
      console.log(
        '[DashboardApproval] approval-timeline - resposta:',
        response,
      );
    } catch (error) {
      console.warn(
        '[DashboardApproval] approval-timeline - usando mock (EP 404 ou erro):',
        error,
      );
      data = DashboardApprovalComponent.APPROVAL_TIMELINE_MOCK;
    }
    console.log(
      '[DashboardApproval] approval-timeline - itens brutos usados (formato esperado do EP):',
      data,
    );
    this.approvalStepsTimeline = this.mapApprovalTimelineToSteps(data);
    this.cdr.detectChanges();
  }

  /**
   * Mapeia resposta da API v3 para UserApprovalResponse
   */
  private mapV3ResponseToApproval(response: any): UserApprovalResponse {
    const v3Data = response.data;

    // Tentar diferentes caminhos para encontrar os dados
    let versionData = v3Data.versions?.complementary?.versions?.[0];
    let registerData = versionData?.data;
    let registerInfo = v3Data.data?.register;
    let approvalInfo = v3Data.data?.approval;
    let registerType = v3Data.register_type;

    // Se não encontrou no caminho padrão, tentar alternativas
    if (!versionData && v3Data.versions?.complementary) {
      // Pode ser que versions seja um array direto
      if (Array.isArray(v3Data.versions.complementary)) {
        versionData = v3Data.versions.complementary[0];
        registerData = versionData?.data;
      } else if (v3Data.versions.complementary.data) {
        // Pode estar em complementary.data diretamente
        registerData = v3Data.versions.complementary.data;
        versionData = v3Data.versions.complementary;
      }
    }

    // Se ainda não encontrou registerData, tentar outros caminhos
    if (
      !registerData ||
      (!registerData.full_name && !registerData.corporate_name)
    ) {
      // Se versionData existe mas não tem os dados corretos, ou se não existe versionData
      // Tentar pegar de v3Data.data.register.person ou v3Data.data.register.company
      if (v3Data.data?.register?.person) {
        registerData = v3Data.data.register.person;
      } else if (v3Data.data?.register?.company) {
        registerData = v3Data.data.register.company;
      } else if (v3Data.data && !Array.isArray(v3Data.data)) {
        // Último recurso: usar v3Data.data diretamente
        registerData = v3Data.data;
      }
    }

    // Se registerType ainda for null, tentar inferir de outras fontes
    if (!registerType) {
      // Tentar pegar do registerInfo
      if (registerInfo?.type) {
        registerType = registerInfo.type;
      } else if (registerData?.type) {
        registerType = registerData.type;
      } else if (registerData?.full_name) {
        // Se tem full_name, provavelmente é PF
        registerType = 'PF';
      } else if (registerData?.corporate_name) {
        // Se tem corporate_name, provavelmente é PJ
        registerType = 'PJ';
      }
    }

    // Se registerInfo não foi encontrado, tentar construir a partir de v3Data.data
    if (!registerInfo && v3Data.data) {
      registerInfo = v3Data.data.register || v3Data.data;
    }

    // Verificação final: se registerData não tem os dados de pessoa/empresa,
    // tentar pegar diretamente de v3Data.data.register ou outras estruturas
    if (
      registerData &&
      !registerData.full_name &&
      !registerData.corporate_name
    ) {
      // Se registerData existe mas não tem nome, pode estar em v3Data.data.register
      if (v3Data.data?.register?.person) {
        registerData = v3Data.data.register.person;
        if (!registerType) registerType = 'PF';
      } else if (v3Data.data?.register?.company) {
        registerData = v3Data.data.register.company;
        if (!registerType) registerType = 'PJ';
      } else if (
        v3Data.data &&
        typeof v3Data.data === 'object' &&
        !Array.isArray(v3Data.data)
      ) {
        // Se v3Data.data é um objeto mas não tem register, pode ser que os dados estejam diretamente nele
        // Verificar se tem full_name ou corporate_name diretamente
        if ((v3Data.data as any).full_name) {
          registerData = v3Data.data as any;
          if (!registerType) registerType = 'PF';
        } else if ((v3Data.data as any).corporate_name) {
          registerData = v3Data.data as any;
          if (!registerType) registerType = 'PJ';
        }
      }
    }

    // Montar objeto register
    // Garantir que registerType não seja null
    const finalRegisterType = (registerType || 'PF') as UserTypes;

    const registerUuidFromV3 =
      v3Data?.register_uuid != null
        ? String(v3Data.register_uuid).trim()
        : '';
    const registerUuidFromInfo =
      registerInfo?.register_uuid != null
        ? String(registerInfo.register_uuid).trim()
        : '';
    const resolvedRegisterUuid = registerUuidFromV3 || registerUuidFromInfo;

    const register: Register = {
      type: finalRegisterType,
      role: registerInfo?.role || ({} as Role),
      roles: (registerInfo?.roles || []) as any, // Adicionar roles do registerInfo
      papers: Array.isArray(registerInfo?.papers) ? registerInfo.papers : [],
      agent: registerInfo?.agent || [],
      is_simplified: registerInfo?.is_simplified || false,
      active:
        typeof registerInfo?.active === 'boolean' ? registerInfo.active : true,
      current_stage: registerInfo?.current_stage,
      person: finalRegisterType === 'PF' ? registerData : null,
      company: finalRegisterType === 'PJ' ? registerData : null,
      // Campos adicionais que podem ser necessários
      address: null,
      bank_information: registerData?.bank_information || [],
      economic_group: registerData?.economic_group || [],
      cards: registerData?.cards || {},
      signatures: v3Data.data?.signatures || [],
      representatives: [],
      partners: [],
      pep_relation: [],
      investor_profile_pj: [],
      investor_profile_pf: [],
      investor_profile_quiz: [],
      profiles_quiz: [],
      declaration_authorization: [],
      files: [],
      approval: [],
      avalista: false,
      guarantor: false,
      spousal_consent: false,
      is_approver: false,
      name: (() => {
        // Tentar múltiplos caminhos para encontrar o nome
        const name =
          registerData?.full_name ||
          registerData?.corporate_name ||
          registerInfo?.name ||
          v3Data.data?.name ||
          registerInfo?.person?.full_name ||
          registerInfo?.company?.corporate_name ||
          v3Data.data?.register?.person?.full_name ||
          v3Data.data?.register?.company?.corporate_name ||
          // Tentar em v3Data.data diretamente (pode estar em diferentes estruturas)
          (v3Data.data &&
          typeof v3Data.data === 'object' &&
          !Array.isArray(v3Data.data)
            ? (v3Data.data as any).full_name
            : null) ||
          (v3Data.data &&
          typeof v3Data.data === 'object' &&
          !Array.isArray(v3Data.data)
            ? (v3Data.data as any).corporate_name
            : null) ||
          // Tentar em versionData?.data diretamente se existir
          (versionData?.data &&
          typeof versionData.data === 'object' &&
          !Array.isArray(versionData.data)
            ? (versionData.data as any).full_name
            : null) ||
          (versionData?.data &&
          typeof versionData.data === 'object' &&
          !Array.isArray(versionData.data)
            ? (versionData.data as any).corporate_name
            : null) ||
          '';

        return name;
      })(),
      // id do cadastro = UUID v3 (data.register_uuid); não usar id de person/company (ex.: 3221)
      id:
        resolvedRegisterUuid ||
        registerInfo?.id?.toString() ||
        registerData?.id?.toString() ||
        '',
      register_uuid: resolvedRegisterUuid || undefined,
      created_at: registerData?.created_at || '',
      updated_at: registerData?.updated_at || '',
      current_revision: registerData?.current_revision || null,
      status:
        registerInfo?.current_stage === 'Em aprovação'
          ? 'pending'
          : registerInfo?.current_stage === 'Homologado'
            ? 'approved'
            : registerInfo?.current_stage === 'Rejeitado'
              ? 'rejected'
              : 'created',
      status_display: registerInfo?.current_stage || '',
      type_display:
        finalRegisterType === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica',
      trace_step: null,
      interest_fund: null,
      invite: null,
    };

    // Mapear current_department corretamente
    let currentDepartment: UserApprovalQueueDepartment | null = null;
    if (v3Data.current_department) {
      const dept = v3Data.current_department;
      currentDepartment = {
        id: dept.id,
        type: 'department' as 'department' | 'agent',
        sign_quantity: dept.sign_quantity || 1,
        order: 0, // Não vem na v3, usar 0 como padrão
        user_approval_queue: 0, // Não vem na v3
        type_display: 'Departamento',
        department:
          dept.department ||
          (dept.name
            ? ({
                id: dept.id,
                name: dept.name,
                description: '',
                color: '',
                role: 0,
              } as Department)
            : null),
        agent: null,
      };
    }

    // Montar objeto approval
    const approval: UserApprovalResponse = {
      id: approvalInfo?.id || versionData?.approval_id || 0,
      version_number:
        versionData?.version_number || approvalInfo?.version_number || 0,
      register: register,
      user: null, // Não vem na v3, pode ser null
      versions: [], // Será preenchido por loadVersionsFromV3
      fund: null,
      queue: v3Data.queue || null,
      current_department: currentDepartment,
      step: approvalInfo?.step || 0,
      attempt: approvalInfo?.attempt || 1,
      can_sign: approvalInfo?.can_sign || false,
      completed: approvalInfo?.completed || false,
      is_approved: approvalInfo?.is_approved || false,
      homologated: approvalInfo?.homologated || false,
      editing: approvalInfo?.editing || false,
      created_at: approvalInfo?.created_at || versionData?.created_at || '',
      updated_at: approvalInfo?.updated_at || '',
      valid_until: approvalInfo?.valid_until || null,
      investor_profile_pj: [],
      investor_profile_pf: [],
      investor_profile_quiz: [],
      profiles_quiz: [],
      type: finalRegisterType,
      user_details: v3Data.data?.user_details || null,
      signatures: v3Data.data?.signatures || [],
      cards: registerData?.cards || {},
      registers_users: [],
      revision: versionData?.id || null,
      is_draft: approvalInfo?.is_draft || false,
      history: null,
      approved_by: approvalInfo?.approved_by || null,
      rejected_by: approvalInfo?.rejected_by || null,
      homologated_by: approvalInfo?.homologated_by || null,
      returned_by: approvalInfo?.returned_by || null,
      created_by_name:
        versionData?.created_by_name || approvalInfo?.created_by_name,
    };

    return approval;
  }

  async getApproval(version: number = null) {
    // Ativar loading para mostrar skeletons
    this.loading = true;
    this.signing = true;

    if (this.authService.user) {
      const user_role = this.authService.user.active_register
        ? this.authService.user.active_register.register.role
        : this.authService.user.role;

      this.applicableRole = user_role.slug.split('-')[0];
    } else {
      this.applicableRole = 'ASSIGNOR';
    }

    try {
      // Buscar approval da API v3
      const approval = await this.getApprovalFromV3(version);

      if (!approval) {
        throw new Error('Não foi possível carregar os dados do approval');
      }

      // Definir role baseado nos roles do approval (prioridade) ou role único (fallback)
      const register = approval.register as any;
      if (
        register.roles &&
        Array.isArray(register.roles) &&
        register.roles.length > 0
      ) {
        // Usar o primeiro role como padrão (ou o que estiver em aprovação, não em rascunho)
        const activeRole =
          register.roles.find((r: any) => r && r.status_code !== 'draft') ||
          register.roles[0];
        this.role = activeRole?.applicable || this.role;
      } else if (register.role?.applicable) {
        // Fallback para role único
        this.role = register.role.applicable;
      }

      if (
        register.roles &&
        Array.isArray(register.roles) &&
        register.roles.length > 0
      ) {
        this.hasRepresentativeRole = register.roles.some(
          (r: any) => r?.applicable === 'representative',
        );
        this.isOnlyRepresentative = register.roles.every(
          (r: any) => r?.applicable === 'representative',
        );
      } else {
        this.hasRepresentativeRole =
          register.role?.applicable === 'representative';
        this.isOnlyRepresentative = this.hasRepresentativeRole;
      }

      // Carregar versões da API v3 para garantir dados atualizados
      await this.loadVersionsFromV3();

      // Atualizar versões no approval se necessário
      if (this.allApprovals && this.allApprovals.length > 0) {
        approval.versions = this.allApprovals;
      }

      this.handleSetTabs(approval);

      // Sincronizar tabIndex com activedTab após recriar as tabs
      if (this.activedTab) {
        const tabIndex = this.tabs.findIndex(
          (tab) => tab.value === this.activedTab,
        );
        if (tabIndex !== -1) {
          this.tabIndex = tabIndex;
        }
        // Atualizar aba ativa no service
        this.approvalService.approvalData.activeTab = this.activedTab;
      }

      // Atualizar versão selecionada se estiver no modo de visualização
      if (this.showVersionSelector && this.allApprovals) {
        this.selectedVersion =
          this.allApprovals.find(
            (v) => v.version_number === approval.version_number,
          ) || null;
      }

      this.setBreadcrumb(); // Atualizar breadcrumb após carregar os dados
      this.checkRegistrationExpiration(); // Verificar expiração do registro
      await this.checkRoleDraft(); // Verificar se existe role_draft

      // SEMPRE buscar a área do usuário para garantir que está atualizada
      await this.getUserArea();

      // Buscar status de assinatura dos representantes
      //   await this.getRegistrationSignStatus();

      this.loading = false;
      this.signing = false;

      // Verificar se o usuário pertence ao departamento atual do cadastro
      // Se pertencer e can_sign for true, ele pode aprovar
      // Se for master/owner, sempre pode aprovar
      if (
        this.isMasterUser() ||
        (this.approval &&
          this.approval.can_sign &&
          this.isUserInCurrentDepartment())
      ) {
        this.isApprover = true;
      }

      // Revalidar permissões após carregar o approval (importante para owner/master)
      this.setPermissions();

      return;
    } catch (error) {
      console.error('[DashboardApproval] getApproval - ERRO:', error);
      this.toast.show('error', 'Erro', 'Erro ao carregar dados: ' + error);
    }

    this.loading = false;
    this.signing = false;
  }

  /**
   * Retorna as tabs apropriadas para um role específico e tipo
   */
  private getTabsForRole(role: string, type: string, isFund: boolean): Tab[] {
    const tabs: Tab[] = [];

    // Tabs comuns a todos
    tabs.push({ label: 'Dados básicos', value: 'complementary' });

    // Tabs específicas por role e tipo
    if (role === 'shareholder') {
      if (type === 'PF') {
        tabs.push(
          { label: 'Declarações & autorizações', value: 'declarations' },
          { label: 'Informações de risco', value: 'risk' },
          { label: 'Profissional', value: 'professional' },
          { label: 'Rendimentos e patrimônios', value: 'income' },
        );
      } else if (type === 'PJ') {
        tabs.push(
          { label: 'Declarações & autorizações', value: 'declarations' },
          { label: 'Informações de risco', value: 'risk' },
          { label: 'Composição acionária', value: 'composition' },
        );
      }
    } else if (role === 'assignor') {
      if (type === 'PF') {
        tabs.push({ label: 'Profissional', value: 'professional' });
      } else if (type === 'PJ') {
        tabs.push({ label: 'Composição acionária', value: 'composition' });
      }
    } else if (role === 'provider') {
      if (type === 'PF') {
        // tabs.push({ label: 'Profissional', value: 'professional' });
      } else if (type === 'PJ') {
        tabs.push({ label: 'Composição acionária', value: 'composition' });
      }
    }

    // Tabs comuns finais
    tabs.push(
      { label: 'Representantes', value: 'representatives' },
      { label: 'Grupos e poderes', value: 'powers' },
      { label: 'Anexos', value: 'attachments' },
      { label: 'Fundos de interesse', value: 'funds' },
      { label: 'Documentos', value: 'documents' },
    );

    // Documentos Internos para master/common
    if (this.isMasterOrCommonUser()) {
      tabs.push({ label: 'Documentos Internos', value: 'internal-documents' });
    }

    return tabs;
  }

  private async getRegistrationSignStatus() {
    const register_uuid = this.route?.snapshot?.params?.id;
    if (!register_uuid) {
      this.loadingRepresentativeStep = false;
      return;
    }

    try {
      this.loadingRepresentativeStep = true;
      const authUser = this.authService.getUser();
      const authRegisterUuid = authUser?.active_register?.register?.id;
      const authUserId = authUser?.id;
      const response = await this.api.get<{
        data: Array<{
          id: number;
          representative_register_uuid: string;
          full_name: string;
          document_number: string;
          signs_registration_form: boolean;
          is_registration_form_mandatory: boolean;
          has_signed: boolean;
        }>;
      }>({
        route: 'api/registration/registration-sign-status/',
        params: { register_uuid },
        token: true,
      });

      const signStatusList = response?.data || [];
      const representativeStatus =
        signStatusList.find((item) => item?.id === authUserId) ||
        (authRegisterUuid
          ? signStatusList.find(
              (item) => item?.representative_register_uuid === authRegisterUuid,
            )
          : null);
      this.isRepresentativeViewer = !!representativeStatus;
      this.representativeSignId = representativeStatus?.id ?? null;
      this.representativeSignRequired = !!(
        representativeStatus?.signs_registration_form ||
        representativeStatus?.is_registration_form_mandatory
      );
      this.representativeHasSigned = !!representativeStatus?.has_signed;
      this.approvalService.approvalData.representativeSignStatus =
        response?.data || [];
      this.approvalService.updateRepresentativeSignStatus.emit();

      const signRequired = (response?.data || []).filter(
        (item) => item?.signs_registration_form,
      );
      const representativeSignStatus = {
        total: signRequired.length,
        signed: signRequired.filter((item) => item?.has_signed).length,
      };

      if (this.approval) {
        (this.approval as any).representative_sign_status =
          representativeSignStatus;
      }
    } catch (error) {
      console.error(
        '[DashboardApproval] registration-sign-status - ERRO:',
        error,
      );
    } finally {
      this.loadingRepresentativeStep = false;
    }
  }

  async handleSetTabs(approval) {
    this.tabs = [];

    // Verificar scroll após definir tabs
    setTimeout(() => {
      this.checkScrollButtons();
    }, 0);

    this.isSimplified = approval?.register?.is_simplified;
    this.approval = approval;

    // Timeline de aprovação é preenchida por loadApprovalTimeline() (EP ou mock)

    // Garantir que register.type não seja null - tentar inferir se necessário
    if (!this.approval?.register?.type) {
      const personData = this.approval?.register?.person;
      const companyData = this.approval?.register?.company;
      if (personData && (personData as any).full_name) {
        this.approval.register.type = 'PF';
      } else if (companyData && (companyData as any).corporate_name) {
        this.approval.register.type = 'PJ';
      } else {
        // Se ainda não encontrou, usar fallback baseado no role ou default PF
        this.approval.register.type = 'PF'; // Fallback padrão
      }
    }

    // Armazenar approval no serviço para sincronização com API v3
    this.approvalService.approvalData.approval = approval;

    const register = approval.register as any;
    const registerType = this.approval.register.type;

    if (this.isOnlyRepresentative) {
      this.tabs = [
        { label: 'Dados básicos', value: 'complementary' },
        { label: 'Anexos', value: 'attachments' },
        { label: 'Documentos', value: 'documents' },
      ];
      return;
    }

    // Verificar se é fundo (verificar em role ou roles)
    this.isFund =
      register.role?.slug?.includes('PJ-FI') ||
      (register.roles &&
        Array.isArray(register.roles) &&
        register.roles.some((r: any) => r?.slug?.includes('PJ-FI')));

    // Verificar se há roles (array de múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      // Usar todos os roles, incluindo os que estão em rascunho
      // Isso garante que todas as tabs sejam geradas para todos os papéis do usuário
      const rolesToUse = register.roles.filter((r: any) => r && r.applicable);

      // Coletar todas as tabs de todos os roles e unir (sem duplicatas)
      const allTabsMap = new Map<string, Tab>();

      // Sempre adicionar Dados básicos primeiro
      allTabsMap.set('complementary', {
        label: 'Dados básicos',
        value: 'complementary',
      });

      // Processar cada role e adicionar suas tabs
      rolesToUse.forEach((roleItem: any, index: number) => {
        const roleApplicable = roleItem?.applicable;

        if (roleApplicable) {
          const roleTabs = this.getTabsForRole(
            roleApplicable,
            registerType,
            this.isFund,
          );

          // Adicionar tabs ao mapa (evita duplicatas)
          roleTabs.forEach((tab) => {
            if (!allTabsMap.has(tab.value)) {
              allTabsMap.set(tab.value, tab);
            }
          });
        }
      });

      // Converter mapa para array e ordenar (manter ordem lógica)
      const orderedTabs: Tab[] = [];
      const tabOrder = [
        'complementary',
        'declarations',
        'risk',
        'professional',
        'income',
        'composition',
        'representatives',
        'powers',
        'attachments',
        'funds',
        'documents',
        'internal-documents',
      ];

      tabOrder.forEach((value) => {
        if (allTabsMap.has(value)) {
          orderedTabs.push(allTabsMap.get(value)!);
          allTabsMap.delete(value);
        }
      });

      // Adicionar qualquer tab restante que não estava na ordem
      allTabsMap.forEach((tab) => {
        orderedTabs.push(tab);
      });

      this.tabs = orderedTabs;
    } else {
      // Fallback para role único (comportamento anterior)
      const singleRole = register.role?.applicable || this.role;

      // Verificar se é cotista PJ fundo (shareholder + PJ + fundo)
      if (
        singleRole === 'shareholder' &&
        registerType === 'PJ' &&
        this.isFund
      ) {
        // Para cotista PJ fundo, adicionar as tabs solicitadas
        this.tabs = [
          { label: 'Dados básicos', value: 'complementary' },
          { label: 'Fundos de interesse', value: 'funds' },
          //   { label: 'Informações de risco', value: 'risk' },
          { label: 'Declarações & autorizações', value: 'declarations' },
          { label: 'Documentos', value: 'documents' },
          ...(this.isMasterOrCommonUser()
            ? [{ label: 'Documentos Internos', value: 'internal-documents' }]
            : []),
          { label: 'Anexos', value: 'attachments' },
        ];

        return;
      }

      if (this.isFund) {
        this.tabs = [
          { label: 'Dados básicos', value: 'complementary' },
          ...(this.isMasterOrCommonUser()
            ? [{ label: 'Documentos Internos', value: 'internal-documents' }]
            : []),
        ];

        return;
      }

      // Usar a função auxiliar para obter tabs do role único
      this.tabs = this.getTabsForRole(singleRole, registerType, this.isFund);
    }

    if (this.approval?.register?.type === 'PJ') {
      this.getPartners();

      // Comentado para deixar apenas dados básicos
      // let filters = ['professional'];
      // if (this.role !== 'shareholder') {
      //   filters.push('income');
      //   this.tabs.splice(1, 0, {
      //     label: 'Composição acionária',
      //     value: 'composition',
      //   });
      // } else {
      //   this.tabs.splice(1, 0, {
      //     label: 'Rendimentos e patrimônios',
      //     value: 'income',
      //   });
      // }
      // if (this.role === 'shareholder') {
      //   this.tabs.splice(
      //     1,
      //     0,
      //     { label: 'Declarações & autorizações', value: 'declarations' },
      //     { label: 'Informações de risco', value: 'risk' }
      //   );
      // }
      // this.tabs = this.tabs.filter((tab) => !filters.includes(tab.value));
    }

    // Filtrar a aba "Documentos Internos" quando estiver comparando versões
    if (this.comparingVersions) {
      this.tabs = this.tabs.filter((tab) => tab.value !== 'internal-documents');

      // Se a aba ativa for "internal-documents", redirecionar para "complementary"
      if (this.activedTab === 'internal-documents') {
        this.activedTab = 'complementary';
        const complementaryIndex = this.tabs.findIndex(
          (tab) => tab.value === 'complementary',
        );
        if (complementaryIndex !== -1) {
          this.tabIndex = complementaryIndex;
        }
        this.approvalService.approvalData.activeTab = 'complementary';
      }
    }
  }

  //   async getProviders(ids: number[]) {
  //     await Promise.all([
  //       this.getProvider(ids, 'admin'),
  //       this.getProvider(ids, 'manager'),
  //     ]);
  //   }

  //   async getProvider(ids: number[], role: string) {
  //     try {
  //       const res = await this.api.get({
  //         route: 'api/registration/register_admin',
  //         token: true,
  //         params: {
  //           funds: [ids],
  //           role: role,
  //         },
  //       });

  //       const data = res.map((item: any) => {
  //         return {
  //           label: item.name,
  //           value: item.id,
  //           extra: item.document,
  //           role: item.role,
  //         };
  //       });

  //       const selectedProvider = data.find(
  //         (item) => item.value === this.approval.register[role]
  //       );

  //       this.provider[role] = selectedProvider;
  //     } catch (error) {
  //       //   this.toast.show('error', 'Erro!', 'Erro ao carregar administradores');
  //     }
  //   }

  async getPartners() {
    this.register_id = this.route.snapshot.params.id;

    try {
      const data = await this.api.get<PartnerResponse[]>({
        route: `api/registration/partners/?id=${this.register_id}`,
        token: true,
      });

      this.partners = data;

      this.formatData();
    } catch (error) {}
  }

  formatData() {
    const firstObject: PartnerResponse = {
      id: undefined,
      percentage: 0,
      isOpen: true,
      pep: false,
      full_name: 'Grupo principal',
      document: '',
      parent: null,
      title: '',
      pep_bond: '',
      pep_relationship: false,
      pep_relationship_document: '',
      pep_relationship_name: '',
      shareholders: [],
      register: '',
      collapsed: false,
    };

    const rootObjects = [];

    const partnersData = this.approval.history.Partners || this.partners;

    partnersData.forEach((item) => {
      if (item.parent === null) {
        firstObject.shareholders.push(item);
      }

      if (item.document.length > 14) {
        rootObjects.push(item);
      }
    });

    const newData = partnersData.map((item) => {
      return {
        ...item,
        collapsed: false,
        isOpen: true,
      };
    });

    const newFormattedData = [firstObject, ...newData];

    this.formattedData = newFormattedData;
  }

  filteredApproval(attempt, approval) {
    return approval.filter((_approval) => _approval.attempt === attempt);
  }

  closeWarningModal() {
    this.warningModal = false;

    this.reproveForm.reset();
    this.homologateForm.reset();
  }

  handleApproval(
    approve: boolean,
    reset?: boolean,
    homologated: boolean = false,
  ) {
    if (this.isApproveDisabled()) {
      return;
    }

    this.approve = approve;
    this.warningModal = true;
    this.resetApproval = reset ?? false;
    this.homologated = homologated;
    this.showCtaOptions = false;

    // Forçar detecção de mudanças para garantir que o modal seja exibido
    // Usar setTimeout para garantir que a mudança seja detectada após o ciclo atual
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  formatPhone(phone) {
    return this.maskPipe.transform(phone, '(00) 00000-0000');
  }

  async signApproval(approve: boolean, homologated: boolean = false) {
    if (homologated && this.homologateForm.invalid) {
      return;
    }

    // Ativar loading spinner fullscreen
    this.signing = true;

    try {
      if (
        approve &&
        (this.isMasterUser() || this.userArea === 'Todos (Usuário Master)')
      ) {
        const signedRepresentatives =
          await this.signPendingRepresentativesAsMaster();
        if (signedRepresentatives && !homologated) {
          this.signing = false;
          this.warningModal = false;
          return;
        }
      }

      // Sempre usar o current_department.id que vem da API v3 (complementary)
      // Este valor é atualizado automaticamente via updateApprovalQueue
      const departmentApprovalId = this.approval?.current_department?.id;

      if (!departmentApprovalId) {
        this.toast.show(
          'error',
          'Erro',
          'Departamento de aprovação não encontrado',
        );
        this.signing = false;
        return;
      }

      let payload: any = homologated
        ? {
            reason: this.homologateForm.value.reason || '',
            signed: true,
            restart: false,
            department_approval_id: departmentApprovalId,
            approved: true,
            user_approval: {
              id: this.approval.id,
              approved: true,
              is_draft: false,
              completed: true,
              homologated: true,
              is_approved: true,
            },
            departments: this.approval.queue.departments.map(
              (department) => department.id,
            ),
          }
        : {
            user_approval: this.approval.id,
            department_approval: departmentApprovalId,
            approved: approve,
            restart: this.resetApproval,
            reason: approve ? '' : this.reproveForm.value.description,
            signed: true,
          };

      const res = homologated
        ? await this.api.patch({
            route: `api/approvals/user_approval_signature/`,
            token: true,
            body: payload,
          })
        : await this.api.post({
            route: 'api/approvals/user_approval_signature/',
            token: true,
            body: payload,
          });

      if (approve) {
        this.toast.show(
          'info',
          'Tudo certo',
          `O cadastro foi ${
            homologated ? 'homologado' : 'aprovado'
          } com sucesso`,
        );
      } else {
        this.toast.show(
          'info',
          `Cadastro ${this.resetApproval ? 'retornado' : 'reprovado'}`,
          'Uma notificação foi enviada ao responsável',
        );
      }

      this.warningModal = false;
      this.reproveForm.reset();
      this.homologateForm.reset();

      if (this.resetApproval) {
        // Se for retornar, navegar e desativar spinner
        this.signing = false;
        this.router.navigateByUrl('/app/registers');
      } else {
        // Se não for retornar, chamar getApproval que já gerencia o loading e signing
        // Não precisa setar signing = false aqui, o getApproval() já faz isso
        await this.getApproval();
      }
    } catch (error) {
      this.toast.show('error', 'Erro', 'Erro ao aprovar inscrição');
      // Em caso de erro, desativar o spinner
      this.signing = false;
    }
  }

  private async signPendingRepresentativesAsMaster(): Promise<boolean> {
    const register_uuid = this.route?.snapshot?.params?.id;
    if (!register_uuid) {
      return false;
    }

    let signStatusList =
      this.approvalService.approvalData.representativeSignStatus || [];

    if (!Array.isArray(signStatusList) || signStatusList.length === 0) {
      await this.getRegistrationSignStatus();
      signStatusList =
        this.approvalService.approvalData.representativeSignStatus || [];
    }

    if (!Array.isArray(signStatusList) || signStatusList.length === 0) {
      return false;
    }

    const pendingRepresentatives = signStatusList.filter(
      (item: any) =>
        (item?.signs_registration_form ||
          item?.is_registration_form_mandatory) &&
        !item?.has_signed,
    );

    if (pendingRepresentatives.length === 0) {
      return false;
    }

    await Promise.all(
      pendingRepresentatives.map((item: any) =>
        this.api.patch({
          route: `api/registration/registration-sign-status/${item.id}/`,
          params: { register_uuid },
          body: { has_signed: true },
          token: true,
        }),
      ),
    );

    const updatedList = signStatusList.map((item: any) =>
      pendingRepresentatives.some((pending) => pending.id === item.id)
        ? { ...item, has_signed: true }
        : item,
    );

    this.approvalService.approvalData.representativeSignStatus = updatedList;
    this.approvalService.updateRepresentativeSignStatus.emit();

    const signRequired = updatedList.filter(
      (item: any) => item?.signs_registration_form,
    );
    const representativeSignStatus = {
      total: signRequired.length,
      signed: signRequired.filter((item: any) => item?.has_signed).length,
    };

    if (this.approval) {
      (this.approval as any).representative_sign_status =
        representativeSignStatus;
    }

    return true;
  }

  onChangeTab(index: number) {
    this.activedTab = this.tabs[index].value;
    this.tabIndex = index;

    // Atualizar aba ativa no service para que os componentes saibam qual aba está visível
    this.approvalService.approvalData.activeTab = this.activedTab;

    // Verificar scroll após mudança de tab
    setTimeout(() => {
      this.checkScrollButtons();
      this.scrollToActiveTab();
    }, 0);
  }

  onChangeTabByValue(value: string) {
    const index = this.tabs.findIndex((tab) => tab.value === value);
    if (index !== -1) {
      this.onChangeTab(index);
    }
  }

  scrollTabs(direction: 'left' | 'right') {
    if (!this.tabsWrapper?.nativeElement) return;

    const wrapper = this.tabsWrapper.nativeElement;
    const scrollAmount = 200; // Quantidade de pixels para rolar

    if (direction === 'left') {
      wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    // Verificar estado dos botões após scroll
    setTimeout(() => {
      this.checkScrollButtons();
    }, 300);
  }

  checkScrollButtons() {
    if (!this.tabsWrapper?.nativeElement) {
      this.canScrollLeft = false;
      this.canScrollRight = false;
      return;
    }

    const wrapper = this.tabsWrapper.nativeElement;
    const { scrollLeft, scrollWidth, clientWidth } = wrapper;

    this.canScrollLeft = scrollLeft > 0;
    this.canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    // Verificar scroll quando a janela é redimensionada
    setTimeout(() => {
      this.checkScrollButtons();
    }, 100);
  }

  scrollToActiveTab() {
    if (!this.tabsContainer?.nativeElement || !this.tabsWrapper?.nativeElement)
      return;

    const container = this.tabsContainer.nativeElement;
    const wrapper = this.tabsWrapper.nativeElement;
    const activeTab = container.querySelector('.dashboard-tab.active');

    if (activeTab) {
      const tabLeft = activeTab.offsetLeft;
      const tabWidth = activeTab.offsetWidth;
      const wrapperWidth = wrapper.clientWidth;
      const wrapperScrollLeft = wrapper.scrollLeft;

      // Se a tab ativa está fora da área visível, rolar para ela
      if (tabLeft < wrapperScrollLeft) {
        // Tab está à esquerda da área visível
        wrapper.scrollTo({ left: tabLeft - 20, behavior: 'smooth' });
      } else if (tabLeft + tabWidth > wrapperScrollLeft + wrapperWidth) {
        // Tab está à direita da área visível
        wrapper.scrollTo({
          left: tabLeft + tabWidth - wrapperWidth + 20,
          behavior: 'smooth',
        });
      }

      setTimeout(() => {
        this.checkScrollButtons();
      }, 300);
    }
  }

  getInitials(item: UserApprovalResponse) {
    const full_name =
      item.register.type.toUpperCase() === 'PF'
        ? item.register.person.full_name
        : item.register.company.corporate_name;

    return Utils.getInitials(full_name);
  }

  getMapAddress(approval: any) {
    if (approval.address) {
      const fullAddress = encodeURIComponent(
        `${approval.address.public_place}, ${approval.address.number}, ${approval.address.district}, ${approval.address.city} - ${approval.address.uf}`,
      );
      const mapUrl = `http://maps.google.com/maps?q=${fullAddress}&z=15&output=embed`;

      return this.sanitizer.bypassSecurityTrustResourceUrl(mapUrl);
    }

    return '';
  }

  calculateTotal(properties: any) {
    let total = 0;

    properties.forEach((property: any) => {
      total += Number(property.current_value);
    });

    return total;
  }

  getFileStatus(status: any) {
    switch (status) {
      case 1:
        return 'Arquivo Enviado';
      case 2:
        return 'Reprovado';
      case 3:
        return 'Aprovado';
      default:
        return 'Desconhecido';
    }
  }

  openFileApprovalModal(attachment: any, situation: number) {
    this.currentAttachment = attachment;
    this.currentSituation = situation;
    this.fileDescription = '';

    if (situation === 2) {
      this.showFileRejectionModal = true;
    } else {
      this.showFileApprovalModal = true;
    }
  }

  closeFileApprovalModal() {
    this.showFileApprovalModal = false;
    this.currentAttachment = null;
    this.currentSituation = null;
    this.fileDescription = '';
  }

  closeFileRejectionModal() {
    this.showFileRejectionModal = false;
    this.currentAttachment = null;
    this.currentSituation = null;
    this.fileDescription = '';
  }

  async confirmFileApproval() {
    if (!this.currentAttachment || !this.currentSituation) return;

    try {
      const payload = {
        id: this.currentAttachment.id,
        situation: this.currentSituation,
        description: this.fileDescription,
      };

      await this.api.put({
        route: 'api/approvals/approval_file',
        token: true,
        body: payload,
      });

      this.closeFileApprovalModal();
      this.showFileApprovalSuccessModal = true;
    } catch (error) {
      this.closeFileApprovalModal();
      this.showFileApprovalErrorModal = true;
    }
  }

  async confirmFileRejection() {
    if (!this.currentAttachment || !this.currentSituation) return;

    try {
      const payload = {
        id: this.currentAttachment.id,
        situation: this.currentSituation,
        description: this.fileDescription,
      };

      await this.api.put({
        route: 'api/approvals/approval_file',
        token: true,
        body: payload,
      });

      this.closeFileRejectionModal();
      this.showFileApprovalSuccessModal = true;
    } catch (error) {
      this.closeFileRejectionModal();
      this.showFileApprovalErrorModal = true;
    }
  }

  closeFileApprovalSuccessModal() {
    this.showFileApprovalSuccessModal = false;
  }

  closeFileApprovalErrorModal() {
    this.showFileApprovalErrorModal = false;
  }

  /**
   * Verifica se o cadastro está rejeitado
   */
  isRejected(): boolean {
    return this.approval?.register?.current_stage === 'Rejeitado';
  }

  /**
   * Verifica se o cadastro é de um tipo que permite edição mesmo quando rejeitado
   * (cedente, cotista ou prestador)
   */
  canEditWhenRejected(): boolean {
    if (!this.approval?.register?.role?.applicable) {
      return false;
    }
    const roleApplicable = this.approval.register.role.applicable;
    return (
      roleApplicable === 'assignor' ||
      roleApplicable === 'shareholder' ||
      roleApplicable === 'provider'
    );
  }

  /**
   * Verifica se o botão de editar deve ser escondido
   * Esconde quando rejeitado E o usuário é Master ou Comum, EXCETO se o cadastro for cedente, cotista ou prestador
   */
  shouldHideEditButton(): boolean {
    // Se não estiver rejeitado, não esconde
    if (!this.isRejected()) {
      return false;
    }

    // Se o cadastro for cedente, cotista ou prestador, sempre mostra (mesmo rejeitado)
    // Independente do tipo de usuário (Master, Comum, etc)
    if (this.canEditWhenRejected()) {
      return false;
    }

    // Se estiver rejeitado E o usuário for Master OU Comum, esconde o botão
    // (usando a mesma lógica do header para identificar usuário comum)
    const isMasterOrCommon = this.isMasterUser() || this.isCommonUser();

    if (isMasterOrCommon) {
      return true; // Esconde para Master ou Comum quando rejeitado
    }

    // Para outros tipos de usuário (cedente, cotista, prestador logados), mostra
    return false;
  }

  isInApproval(): boolean {
    if (!this.approval) {
      return false;
    }

    // Está em aprovação quando: não está completo, step > 0, e tem departamento definido
    return (
      !this.approval.completed &&
      this.approval.step > 0 &&
      this.approval.current_department !== undefined
    );
  }

  /**
   * Verifica se o usuário pertence ao departamento atual do cadastro
   * Compara a área do usuário (obtida da API) com o nome do departamento atual
   *
   * IMPORTANTE: Validações robustas para cadastros antigos onde current_department
   * pode estar mal formatado ou incompleto
   */
  isUserInCurrentDepartment(): boolean {
    // IMPORTANTE: NÃO dar bypass para Master aqui
    // Master deve ser verificado em isApproveDisabled() separadamente
    // Aqui só verificamos se o usuário COMUM está no departamento correto

    // Se userArea não foi carregado ainda, retorna false por segurança
    if (!this.userArea) {
      return false;
    }

    // Validações robustas para evitar problemas com cadastros antigos
    if (!this.approval || !this.approval.current_department) {
      return false;
    }

    const currentDept = this.approval.current_department;

    // Verificar se é departamento e comparar o nome
    if (currentDept.type === 'department') {
      // Validação robusta: department deve existir e não ser null
      if (!currentDept.department) {
        // Se department for null/undefined, não pode comparar - retorna false por segurança
        console.warn(
          '[DashboardApproval] current_department.department está null/undefined para cadastro:',
          this.approval.id,
        );
        return false;
      }

      // Validação robusta: department.name deve existir e não ser vazio
      const deptName = currentDept.department.name;
      if (!deptName || typeof deptName !== 'string' || deptName.trim() === '') {
        // Se name for null/undefined/vazio, não pode comparar - retorna false por segurança
        console.warn(
          '[DashboardApproval] current_department.department.name está inválido para cadastro:',
          this.approval.id,
        );
        return false;
      }

      // Função auxiliar para normalizar strings (remove espaços extras, converte para lowercase)
      const normalizeString = (str: string): string => {
        return str?.toLowerCase()?.trim()?.replace(/\s+/g, ' ') || '';
      };

      // Comparar o nome da área do usuário com o nome do departamento atual
      // Normalização robusta para evitar problemas com espaços extras, acentos, etc.
      const userAreaNormalized = normalizeString(this.userArea);
      const deptNameNormalized = normalizeString(deptName);

      // Se após normalização alguma string estiver vazia, retorna false
      if (!userAreaNormalized || !deptNameNormalized) {
        return false;
      }

      return userAreaNormalized === deptNameNormalized;
    }

    // Verificar se é agente (manter lógica anterior para compatibilidade)
    if (currentDept.type === 'agent') {
      const register = this.authService.user.active_register
        ? this.authService.user.active_register.register
        : this.authService.user;

      if (register.agent && register.agent.length > 0) {
        return register.agent.some(
          (_agent) => currentDept.agent?.id === _agent.id,
        );
      }
    }

    // Se não for department nem agent válido, retorna false por segurança
    return false;
  }

  /**
   * Busca a área do usuário da API
   */
  async getUserArea(): Promise<void> {
    try {
      const { data } = await this.api.get<{
        data: {
          total_items: number;
          started_count: number;
          department_pending: number;
          homologated: number;
          show_homologated: boolean;
          show_started_count: boolean;
          show_department_pending: boolean;
          area: string;
          by_role: {
            provider: number;
            assignor: number;
            shareholder: number;
            total: number;
          };
        };
      }>({
        route: 'api/approvals/v3/user_approval/my-area-dashboard/summary/',
        token: true,
      });

      // A área vem diretamente em data.area
      this.userArea = data?.area || null;
    } catch (error) {
      console.error('[DashboardApproval] getUserArea - ERRO:', error);
      this.userArea = null;
    }
  }

  /**
   * Teste: Busca dados de partners da API v3
   */

  /**
   * Verifica se o botão de editar deve estar desabilitado
   */
  isEditDisabled(): boolean {
    // Se o versionamento não estiver completo, desabilita edição
    if (!this.versioningIsComplete) {
      return true;
    }

    // Se estiver no modo "visualizar todas" e a versão selecionada não for a atual, desabilita
    if (this.showVersionSelector && this.selectedVersion) {
      if (!this.isCurrentVersion(this.selectedVersion)) {
        return true;
      }
      // Se estiver na versão atual mas ainda carregando os dados do header, desabilita
      // para garantir que o status seja verificado antes de habilitar
      if (this.loadingHeaderVersion) {
        return true;
      }
    }

    // Se o cadastro estiver homologado, sempre habilita (mas ainda verifica versionamento acima)
    if (this.approval && this.approval.completed && this.approval.is_approved) {
      return this.isInApproval() || this.editingLoading;
    }

    // Se for master, nunca desabilita (exceto se estiver em aprovação)
    if (this.isMasterUser()) {
      return this.isInApproval() || this.editingLoading;
    }

    // Se não estiver na área do usuário, desabilita
    if (!this.isUserInCurrentDepartment()) {
      return true;
    }

    // Desabilita se estiver em aprovação ou carregando
    return this.isInApproval() || this.editingLoading;
  }

  /**
   * Retorna o tooltip do botão de editar
   */
  getEditButtonTooltip(): string {
    // Se o versionamento não estiver completo, mostra tooltip específico
    if (!this.versioningIsComplete) {
      return 'Só é possível editar após os dados desta versão estarem 100% salvos';
    }

    // Se estiver no modo "visualizar todas" e a versão selecionada não for a atual, mostra tooltip específico
    if (this.showVersionSelector && this.selectedVersion) {
      if (!this.isCurrentVersion(this.selectedVersion)) {
        return 'Vá para versão atual para poder editar';
      }
    }

    // Se o cadastro estiver homologado, não mostra tooltip
    if (this.approval && this.approval.completed && this.approval.is_approved) {
      return '';
    }

    if (this.isInApproval()) {
      return 'Cadastro em fase de aprovação';
    }
    if (!this.isMasterUser() && !this.isUserInCurrentDepartment()) {
      return 'Este cadastro não está na sua área';
    }
    // Se o botão estiver habilitado, não mostra tooltip
    if (!this.isEditDisabled()) {
      return '';
    }
    return 'Editar cadastro';
  }

  /**
   * Verifica se o botão de aprovar deve estar desabilitado
   */
  /**
   * Verifica se o botão de aprovar deve estar desabilitado
   */
  isApproveDisabled(): boolean {
    if (!this.approval) {
      return true;
    }

    // Se estiver no modo "visualizar todas" e a versão selecionada não for a atual, desabilita
    if (this.showVersionSelector && this.selectedVersion) {
      if (!this.isCurrentVersion(this.selectedVersion)) {
        return true;
      }
    }

    // IMPORTANTE: Se userArea ainda não foi carregado, desabilita por segurança
    if (!this.userArea) {
      return true;
    }

    // Se o area for "Todos (Usuário Master)", SEMPRE habilita (retorna false)
    if (this.userArea === 'Todos (Usuário Master)') {
      return false;
    }

    const representativeStatus = (this.approval as any)
      ?.representative_sign_status;
    if (
      representativeStatus &&
      typeof representativeStatus.total === 'number' &&
      representativeStatus.total > 0 &&
      (representativeStatus.signed || 0) < representativeStatus.total
    ) {
      return true;
    }

    // Se a area do usuário for igual ao nome do departamento atual, habilita (retorna false)
    if (this.isUserInCurrentDepartment()) {
      return false;
    }

    // Caso contrário, desabilita
    return true;
  }

  /**
   * Retorna o tooltip do botão de aprovar
   */
  getApproveButtonTooltip(): string {
    if (!this.approval) {
      return 'Aprovar cadastro';
    }

    // Se estiver no modo "visualizar todas" e a versão selecionada não for a atual, mostra tooltip específico
    if (this.showVersionSelector && this.selectedVersion) {
      if (!this.isCurrentVersion(this.selectedVersion)) {
        return 'Vá para versão atual para poder editar';
      }
    }

    if (this.approval.completed && this.approval.is_approved) {
      return 'Cadastro já foi aprovado';
    }

    // Se userArea não foi carregado ainda, mostra mensagem apropriada
    if (!this.userArea) {
      return 'Carregando informações...';
    }

    const representativeStatus = (this.approval as any)
      ?.representative_sign_status;
    if (
      representativeStatus &&
      typeof representativeStatus.total === 'number' &&
      representativeStatus.total > 0 &&
      (representativeStatus.signed || 0) < representativeStatus.total
    ) {
      return 'Aguardando assinatura dos representantes';
    }

    // Verificar se é Master através da API (area === "Todos (Usuário Master)")
    const isMasterFromAPI = this.userArea === 'Todos (Usuário Master)';

    // Se não for master (nem pela API nem pelas permissões) e não estiver no departamento correto
    if (
      !isMasterFromAPI &&
      !this.isMasterUser() &&
      !this.isUserInCurrentDepartment()
    ) {
      return 'Este cadastro não está no seu departamento';
    }
    if (!this.approval.can_sign) {
      return 'Você não pode aprovar este cadastro';
    }
    return 'Aprovar cadastro';
  }

  /**
   * Verifica se o usuário tem múltiplos papéis para edição
   */
  hasMultipleRoles(): boolean {
    if (!this.approval || !this.approval.register) {
      return false;
    }
    const register = this.approval.register as any;
    return (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 1
    );
  }

  /**
   * Retorna os papéis disponíveis para edição
   */
  getAvailableEditRoles(): any[] {
    if (!this.approval || !this.approval.register) {
      return [];
    }
    const register = this.approval.register as any;
    const excludeApplicable = (role: any) =>
      role &&
      role.applicable &&
      role.applicable.toLowerCase() !== 'representative';
    if (register.roles && Array.isArray(register.roles)) {
      return register.roles.filter(excludeApplicable);
    }
    // Fallback para role único
    if (register.role && excludeApplicable(register.role)) {
      return [register.role];
    }
    return [];
  }

  /**
   * Alterna o dropdown de seleção de papel para edição
   */
  toggleEditRoleDropdown() {
    if (this.isEditDisabled()) {
      return;
    }
    this.showEditRoleDropdown = !this.showEditRoleDropdown;
  }

  /**
   * Seleciona um papel para edição
   */
  selectEditRole(role: any) {
    this.selectedEditRole = role;
    this.showEditRoleDropdown = false;

    // Guardar o id do papel selecionado no storage para usar no sendApproval
    if (role && role.id) {
      this.storageService.set('selected_role_id', role.id, true);
    }

    // Após selecionar, abrir o modal de aviso
    this.openEditWarningModalAfterRoleSelection();
  }

  /**
   * Continua a adição de papel quando há role_draft
   */
  async continueRoleDraft() {
    if (
      !this.roleDraftInfo ||
      !this.roleDraftInfo.id ||
      !this.roleDraftInfo.applicable
    ) {
      this.toast.show(
        'error',
        'Erro',
        'Informações do papel em andamento não encontradas',
      );
      return;
    }

    if (!this.register_id) {
      this.toast.show('error', 'Erro', 'ID do registro não encontrado');
      return;
    }

    if (!this.approval || !this.approval.register) {
      this.toast.show('error', 'Erro', 'Dados do registro não encontrados');
      return;
    }

    this.loadingContinueRoleDraft = true;

    try {
      // 1. Guardar o id do papel selecionado no storage para usar no sendApproval (forçar como number)
      const roleId = Number(this.roleDraftInfo.id);
      this.storageService.set('selected_role_id', roleId, true);

      // 2. PATCH no register-step para definir o trace step
      await this.api.patch({
        route: `api/registration/register-step/${this.register_id}/`,
        body: { substep: 'general', step: 'register' },
        token: true,
      });

      // 3. Obter o type do registro (PF ou PJ) e converter para lowercase
      const registerType = this.approval.register.type?.toLowerCase() || 'pf';

      // 4. Obter o applicable do role_draft
      const applicable = this.roleDraftInfo.applicable;

      // 5. Redirecionar para a página de cadastro
      this.router.navigate([
        `/signup/${applicable}/${registerType}/${this.register_id}`,
      ]);
    } catch (error) {
      console.error('Erro ao continuar adição de papel:', error);
      this.toast.show('error', 'Erro', 'Erro ao continuar adição de papel');
      this.loadingContinueRoleDraft = false;
    }
  }

  /**
   * Verifica se existe role_draft (adição de papel em andamento)
   */
  async checkRoleDraft() {
    if (!this.approval || !this.approval.register) {
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      return;
    }

    // Obter documento do registro
    let document: string = null;
    const register = this.approval.register as any;

    if (register.type === 'PF' && register.person?.document?.number) {
      document = register.person.document.number.replace(/[^\d]+/g, '');
    } else if (register.type === 'PJ' && register.company?.document?.number) {
      document = register.company.document.number.replace(/[^\d]+/g, '');
    }

    if (!document) {
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      return;
    }

    try {
      const res = await this.api.post({
        route: 'validate-user-paper-exists/',
        body: { document },
        token: true,
      });

      // Verificar se há role_draft (pode estar no nível raiz ou dentro de res.data)
      const roleDraft = res.role_draft || (res.data && res.data.role_draft);

      if (roleDraft !== null && roleDraft !== undefined) {
        this.hasRoleDraft = true;
        this.roleDraftInfo = roleDraft;
      } else {
        this.hasRoleDraft = false;
        this.roleDraftInfo = null;
      }
    } catch (error) {
      console.error('Erro ao verificar role_draft:', error);
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
    }
  }

  /**
   * Abre o modal de aviso após selecionar o papel
   */
  async openEditWarningModalAfterRoleSelection() {
    // Se o cadastro estiver aprovado (completed e is_approved), mostra o modal de aviso
    if (this.approval && this.approval.completed && this.approval.is_approved) {
      this.showEditWarningModal = true;
    } else {
      // Se não estiver aprovado, vai direto para a edição
      this.editingLoading = true;
      try {
        await this.redirectToEdit();
      } finally {
        this.editingLoading = false;
      }
    }
  }

  /**
   * Obtém o nome formatado do papel selecionado
   */
  getSelectedEditRoleName(): string {
    if (!this.selectedEditRole) {
      return '';
    }
    return this.formatRoleName(this.selectedEditRole.applicable);
  }

  async openEditWarningModal() {
    // Se o usuário tiver múltiplos papéis, mostrar dropdown primeiro
    if (this.hasMultipleRoles()) {
      this.showEditRoleDropdown = true;
      return;
    }

    // Se o cadastro estiver aprovado (completed e is_approved), mostra o modal de aviso
    if (this.approval && this.approval.completed && this.approval.is_approved) {
      this.showEditWarningModal = true;
    } else {
      // Se não estiver aprovado, vai direto para a edição
      this.editingLoading = true;
      try {
        await this.redirectToEdit();
      } finally {
        this.editingLoading = false;
      }
    }
  }

  closeEditWarningModal() {
    this.showEditWarningModal = false;
  }

  cancelEditWarningModal() {
    // Limpar o role_id do storage quando cancelar o modal
    this.storageService.remove('selected_role_id');
    // Limpar também a seleção local
    this.selectedEditRole = null;
    // Fechar o modal
    this.closeEditWarningModal();
  }

  async confirmEditRedirect() {
    this.editingFullscreenLoading = true;
    try {
      await this.redirectToEdit();
    } finally {
      this.editingFullscreenLoading = false;
      // Não limpar o storage aqui, pois o role_id será usado no sendApproval
      this.closeEditWarningModal();
    }
  }

  async redirectToEdit() {
    const register_id = this.route.snapshot.params.id;

    await this.api.patch({
      route: `api/registration/register-step/${register_id}/`,
      body: { substep: 'general', step: 'register' },
      token: true,
    });

    const activeUser = this.authService.getUser();

    this.storageService.setEditUser({
      user: activeUser?.active_register?.id,
      register_id: activeUser?.active_register?.register?.id,
    });

    // Determinar qual papel usar: o selecionado ou o padrão
    let roleApplicable = this.approval.register.role.applicable;
    if (this.selectedEditRole && this.selectedEditRole.applicable) {
      roleApplicable = this.selectedEditRole.applicable;
    } else {
      // Se não tiver papel selecionado mas tiver múltiplos papéis, usar o primeiro
      const availableRoles = this.getAvailableEditRoles();
      if (availableRoles.length > 0) {
        roleApplicable = availableRoles[0].applicable;
      }
    }

    // Redirecionar incluindo o register.id da URL na rota
    this.router.navigate([
      `/signup/${roleApplicable}/${this.approval.register.type.toLowerCase()}/${register_id}`,
    ]);
  }

  getDisplayName(item: UserApprovalResponse) {
    if (item.register.type.toUpperCase() === 'PJ') {
      return item.register.company.corporate_name;
    }

    if (item.register.type.toUpperCase() === 'PF') {
      return item.register.person.full_name;
    }

    return '';
  }
  formatRoleName(applicable: string): string {
    if (!applicable) {
      return '';
    }

    const name = applicable.toUpperCase();

    switch (name) {
      case 'ASSIGNOR':
        return 'Cedente';
      case 'SHAREHOLDER':
        return 'Cotista';
      case 'PROVIDER':
        return 'Prestador de Serviço';
      case 'ADMIN':
        return 'Administrador';
      case 'WITNESS':
        return 'Testemunha';
      default:
        return '';
    }
  }

  getDisplayProfileType(item: UserApprovalResponse) {
    if (item.register.is_simplified) {
      return 'Simplificado';
    }

    const register = item.register as any;

    // Verificar se há roles (array de múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      // Formatar todos os papéis e juntar com vírgula
      const roleNames = register.roles
        .filter((role: any) => role && role.applicable)
        .map((role: any) => this.formatRoleName(role.applicable))
        .filter((name: string) => name); // Remover strings vazias

      if (roleNames.length > 0) {
        // Verificar se algum papel é provider para incluir agentes
        const hasProvider = register.roles.some(
          (r: any) => r && r.applicable === 'provider',
        );

        // Obter agentes se houver provider
        const agent =
          hasProvider && register.agent && register.agent.length > 0
            ? register.agent.map((agent: any) => agent.name).join(', ')
            : '';

        // Remover duplicatas dos nomes dos papéis
        const uniqueRoleNames = [...new Set(roleNames)];

        // Pegar o nome do primeiro papel
        const firstRoleName = register.roles[0]?.name || '';

        // Montar a string final
        let result = uniqueRoleNames.join(', ');

        // Se houver provider e agentes, adicionar os agentes
        if (hasProvider && agent) {
          result += ` - ${agent}`;
        }

        result += ` • ${firstRoleName}`;

        return result;
      }
    }

    // Fallback para role único (comportamento anterior)
    if (register.role?.applicable === 'witness') {
      return 'Testemunha • ' + register.role.name;
    }

    if (register.role?.applicable === 'provider') {
      // Para Prestador de Serviço, mostrar com os agents se houver
      const agent =
        register.agent && register.agent.length > 0
          ? register.agent.map((agent: any) => agent.name).join(', ')
          : '';

      return agent ? `Prestador de Serviço - ${agent}` : 'Prestador de Serviço';
    }

    const profile_type_dict = {
      assignor: 'Cedente',
      provider: 'Prestador de serviços',
      shareholder: 'Cotista',
      witness: 'Testemunha',
    };

    const agent =
      register.agent && register.agent.length > 0
        ? register.agent.map((agent: any) => agent.name).join(', ')
        : '';

    return `
      ${profile_type_dict[register.role?.applicable] || ''} ${
        agent ? '- ' + agent : ''
      } • ${register.role?.name || ''}`;
  }

  /**
   * Itens para os badges de papel: prioridade `register.papers` (v3), depois role_controls legado.
   */
  getRoleControlsForDisplay(approval: UserApprovalResponse): any[] {
    if (this.roleControlsList !== null) return this.roleControlsList;
    const reg = approval?.register as Register;
    const papers = reg?.papers;
    if (Array.isArray(papers) && papers.length > 0) return papers;
    const controls = reg?.role_controls;
    return Array.isArray(controls) ? controls : [];
  }

  /** Indica se o role_control é de representante (usado para esconder status/estado). */
  isRepresentativeRoleControl(rc: any): boolean {
    if (!rc) return false;
    const role = rc.role || {};
    const name = (rc.role_name || role.name || '').toString().toLowerCase();
    const applicable = (role.applicable || '').toString().toLowerCase();
    const slug = (role.slug || '').toString().toLowerCase();
    return (
      applicable === 'representative' ||
      slug.includes('representative') ||
      name.includes('representante')
    );
  }

  /** Texto do badge papel (`papers`: role.applicable_display; legado: slug/role_name). */
  getRoleControlPapel(rc: any): string {
    if (!rc) return 'Papel';
    const role = rc.role || {};
    const fromApi = (role.applicable_display || '').toString().trim();
    if (fromApi) return fromApi;
    const slug = (role.slug || '').toString().toUpperCase();
    const applicable = (role.applicable || '').toString().toLowerCase();

    // Mapeamento principal baseado no slug (segue mesma ideia de "Meus Cadastros")
    if (slug.includes('SHAREHOLDER')) {
      // Cotista
      if (slug.includes('-FI')) {
        return 'Cotista Fundo de Investimento';
      }
      return 'Cotista';
    }

    if (slug.includes('ASSIGNOR')) {
      return 'Cedente';
    }

    if (slug.includes('PROVIDER')) {
      return 'Prestador de Serviço';
    }

    if (slug.includes('REPRESENTATIVE')) {
      return 'Representante';
    }

    // Fallback pelo applicable, se slug não ajudar
    switch (applicable) {
      case 'shareholder':
        return 'Cotista';
      case 'assignor':
        return 'Cedente';
      case 'provider':
        return 'Prestador de Serviço';
      case 'representative':
        return 'Representante';
      default:
        break;
    }

    // Fallback final: usar nome que veio da API ou label genérico
    return rc.role_name || role.name || 'Papel';
  }

  /** Texto do badge status (API: status_display | status). Tradução alinhada ao getStatus do dashboard-accounts. */
  getRoleControlStatusText(rc: any): string {
    const currentStage = (rc?.status_display || rc?.status || '')
      .toString()
      .trim();
    if (!currentStage) return '—';
    const lower = currentStage.toLowerCase();
    if (lower === 'editing' || lower === 'em edicao' || lower === 'em edição')
      return 'Em edição';
    if (
      lower === 'in approval' ||
      lower === 'em aprovacao' ||
      lower === 'em aprovação' ||
      lower === 'pending'
    )
      return 'Em aprovação';
    if (
      lower === 'homologated' ||
      lower === 'aprovado' ||
      lower === 'homologado' ||
      lower === 'concluído'
    )
      return 'Homologado';
    if (lower === 'rejected' || lower === 'rejeitado') return 'Rejeitado';
    return currentStage;
  }

  /** Texto do badge estado: `papers.active` (boolean) ou legado state/estado. */
  getRoleControlEstadoText(rc: any): string {
    if (rc && typeof rc.active === 'boolean') {
      return rc.active ? 'Ativo' : 'Inativo';
    }
    const raw = (rc?.state || rc?.estado || '').toString().trim().toLowerCase();
    if (!raw) return '—';
    return raw === 'active' || raw === 'ativo' ? 'Ativo' : 'Inativo';
  }

  /** Classe CSS do badge de status (alinhado ao getStatusBadgeClass do dashboard-accounts). */
  getRoleControlStatusBadgeClass(rc: any): string {
    if (!rc) return 'status-badge status-badge-editing';
    const status = (rc.status_display || rc.status || '').toLowerCase();
    if (/homologado|aprovado|approved|homologated/.test(status))
      return 'status-badge status-badge-homologated';
    if (/rejeitado|rejected/.test(status))
      return 'status-badge status-badge-rejected';
    if (/em aprovação|em_aprovacao|pending/.test(status))
      return 'status-badge status-badge-approval';
    return 'status-badge status-badge-editing';
  }

  /** Classe CSS do badge de estado (Ativo/Inativo; mesmos estilos do dashboard-accounts). */
  getRoleControlEstadoBadgeClass(rc: any): string {
    if (!rc) return 'status-badge status-badge-editing';
    if (typeof rc.active === 'boolean') {
      return rc.active
        ? 'status-badge status-badge-homologated'
        : 'status-badge status-badge-rejected';
    }
    const estado = (rc.state || rc.estado || '')
      .toString()
      .trim()
      .toLowerCase();

    if (estado === 'ativo' || estado === 'active') {
      return 'status-badge status-badge-homologated';
    }

    if (!estado) {
      return 'status-badge status-badge-editing';
    }

    return 'status-badge status-badge-rejected';
  }

  /** Lista de role_controls que podem ser ativados/inativados (exclui representante). */
  getEditableRoleControlsForPaperModal(): any[] {
    if (!this.approval) return [];
    const list = this.getRoleControlsForDisplay(this.approval);
    return (list || []).filter(
      (rc: any) => !this.isRepresentativeRoleControl(rc),
    );
  }

  /** Abre o modal de ativar/inativar papel a partir do dropdown Aprovar cadastro. */
  openPaperStatusModalFromDropdown(): void {
    this.showCtaOptions = false;
    const list = this.getEditableRoleControlsForPaperModal();
    if (list.length === 0) {
      this.toast.show(
        'info',
        'Atenção',
        'Não há papéis disponíveis para ativar ou inativar.',
      );
      return;
    }
    this.selectedPaperRole = list.length === 1 ? list[0] : null;
    this.paperRoleSelectItemsCache = list.map((rc: any) => ({
      label: this.getRoleControlPapel(rc),
      value: rc?.id != null ? rc.id : '',
    }));
    this.paperStatusForm.reset({
      role_control_id: null,
    });
    this.showPaperStatusModal = true;
    this.paperRoleSelectSub?.unsubscribe();
    this.paperRoleSelectSub = this.paperStatusForm
      .get('role_control_id')
      ?.valueChanges?.subscribe(() => this.cdr.detectChanges());
    this.cdr.detectChanges();
  }

  /** Itens para o app-select de papel (label + value). */
  get paperRoleSelectItems(): { label: string; value: string | number }[] {
    return this.getEditableRoleControlsForPaperModal().map((rc: any) => ({
      label: this.getRoleControlPapel(rc),
      value: rc?.id != null ? rc.id : '',
    }));
  }

  /** Papel selecionado: do form quando há vários papéis, ou selectedPaperRole quando há um só. */
  getEffectiveSelectedPaperRole(): any {
    const list = this.getEditableRoleControlsForPaperModal();
    if (list.length <= 1) return this.selectedPaperRole;
    const id = this.paperStatusForm.get('role_control_id')?.value;
    if (id == null || id === '') return null;
    return list.find((rc: any) => rc?.id == id) || null;
  }

  closePaperStatusModal(): void {
    this.paperRoleSelectSub?.unsubscribe();
    this.paperRoleSelectSub = undefined;
    this.showPaperStatusModal = false;
    this.selectedPaperRole = null;
    this.paperRoleSelectItemsCache = [];
    this.paperStatusForm.reset();
    this.cdr.detectChanges();
  }

  /** Papel ativo: `papers.active` ou legado state === 'active'. */
  isRoleControlActive(rc: any): boolean {
    if (rc && typeof rc.active === 'boolean') return rc.active;
    return (rc?.state ?? '').toString().toLowerCase() === 'active';
  }

  /** Alinhado a dashboard-user-list (getPaperActionTitle). */
  getPaperActionTitleApproval(): string {
    const rc = this.getEffectiveSelectedPaperRole();
    if (!rc) return 'Ativar ou inativar papel';
    return this.isRoleControlActive(rc) ? 'Inativar Papel' : 'Ativar Papel';
  }

  /** Alinhado a dashboard-user-list (getPaperActionMessage). */
  getPaperActionMessageApproval(): string {
    const rc = this.getEffectiveSelectedPaperRole();
    if (!rc) return '';
    return this.isRoleControlActive(rc)
      ? 'Tem certeza que deseja inativar o papel'
      : 'Tem certeza que deseja ativar o papel';
  }

  getRoleLabelForModalApproval(): string {
    const rc = this.getEffectiveSelectedPaperRole();
    return rc ? this.getRoleControlPapel(rc) : 'este papel';
  }

  getDisplayNameForApproval(): string {
    if (!this.approval?.register) return '—';
    const reg = this.approval.register as any;
    if (reg.type?.toUpperCase() === 'PF' && reg.person?.full_name)
      return reg.person.full_name;
    if (reg.type?.toUpperCase() === 'PJ' && reg.company?.corporate_name)
      return reg.company.corporate_name;
    return reg.company_name || reg.corporate_name || '—';
  }

  /**
   * Mesmo contrato que dashboard-user-list.confirmPaperStatusChange:
   * PATCH api/v2/registration/registration-papers/{paperId}/ body { active }.
   */
  async confirmPaperStatusChange(): Promise<void> {
    const list = this.getEditableRoleControlsForPaperModal();
    if (list.length > 1) {
      this.paperStatusForm.get('role_control_id')?.markAsTouched();
    }

    const rc = this.getEffectiveSelectedPaperRole();
    if (!this.approval || !rc) {
      if (list.length > 1) {
        this.toast.show(
          'error',
          'Erro',
          'Selecione um papel para continuar.',
        );
      }
      return;
    }

    const paperId = rc?.id != null ? String(rc.id).trim() : '';
    if (!paperId) {
      this.toast.show(
        'error',
        'Erro',
        'Dados insuficientes para alterar o status do papel.',
      );
      return;
    }

    const currentlyActive = this.isRoleControlActive(rc);
    const active = !currentlyActive;

    this.paperStatusSubmitting = true;
    try {
      await this.api.patch({
        route: `api/v2/registration/registration-papers/${paperId}/`,
        token: true,
        body: { active },
      });
      this.toast.show(
        'info',
        'Sucesso',
        currentlyActive
          ? 'Papel inativado com sucesso.'
          : 'Papel ativado com sucesso.',
      );
      this.closePaperStatusModal();
      await this.getApproval(this.approval?.version_number ?? null);
      this.cdr.detectChanges();
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Não foi possível alterar o status do papel. Tente novamente.',
      );
    } finally {
      this.paperStatusSubmitting = false;
      this.cdr.detectChanges();
    }
  }

  /**
   * UUID do cadastro para `api/v3/registration/registers/`.
   * Prioriza rota (`register_id`) e `register.register_uuid`; evita id numérico de person/company.
   */
  getRegisterUuidForRegistersApi(): string {
    const fromRoute = this.register_id || this.route.snapshot.params?.id;
    if (fromRoute) return String(fromRoute).trim();
    const reg = this.approval?.register as Register | undefined;
    if (reg?.register_uuid) return String(reg.register_uuid).trim();
    if (reg?.id) return String(reg.id).trim();
    return '';
  }

  /** Cadastro ativo/inativo a partir de `register.active`. */
  isCurrentRegisterActive(): boolean {
    const reg = this.approval?.register as Register | undefined;
    if (reg && typeof reg.active === 'boolean') return reg.active;
    return true;
  }

  getRegisterCadastroStatusLabel(): string {
    return this.isCurrentRegisterActive() ? 'Cadastro ativo' : 'Cadastro inativo';
  }

  getRegisterCadastroStatusBadgeClass(): string {
    return this.isCurrentRegisterActive()
      ? 'status-badge status-badge-homologated'
      : 'status-badge status-badge-rejected';
  }

  getRegisterCadastroDropdownLabel(): string {
    return this.isCurrentRegisterActive() ? 'Inativar cadastro' : 'Ativar cadastro';
  }

  getRegisterCadastroModalTitle(): string {
    return this.isCurrentRegisterActive() ? 'Inativar Cadastro' : 'Ativar Cadastro';
  }

  getRegisterPapersRawFromApproval(): any[] {
    const reg = (this.approval?.register as any) ?? {};
    return Array.isArray(reg.papers) ? reg.papers : [];
  }

  getRegisterPapersForActivationFromApproval(): { id: string; label: string }[] {
    return this.getRegisterPapersRawFromApproval()
      .map((p: any) => ({
        id: p?.id != null ? String(p.id).trim() : '',
        label: this.getRoleControlPapel(p),
      }))
      .filter((x) => x.id);
  }

  isRegisterActivationSinglePaperApproval(): boolean {
    if (!this.approval || this.isCurrentRegisterActive()) return false;
    return this.getRegisterPapersForActivationFromApproval().length === 1;
  }

  getSingleRegisterActivationPaperLabelApproval(): string {
    const papers = this.getRegisterPapersForActivationFromApproval();
    return papers[0]?.label ?? '—';
  }

  isRegisterActivationMultiPaperApproval(): boolean {
    if (!this.approval || this.isCurrentRegisterActive()) return false;
    return this.getRegisterPapersForActivationFromApproval().length > 1;
  }

  isRegisterActivationConfirmDisabledApproval(): boolean {
    if (!this.approval || this.isCurrentRegisterActive()) return false;
    if (!this.isRegisterActivationMultiPaperApproval()) return false;
    if (this.registerActivateAllPapers) return false;
    const raw = this.registerActivatePapersForm.get('paperIds')?.value;
    const ids = Array.isArray(raw) ? raw : [];
    return ids.length === 0;
  }

  onRegisterActivateAllToggleApproval(): void {
    if (this.registerActivateAllPapers) {
      this.registerActivatePapersForm.patchValue({ paperIds: [] });
    }
  }

  getRegisterCadastroActionMessage(): string {
    return this.isCurrentRegisterActive()
      ? 'Tem certeza que deseja inativar o cadastro'
      : 'Tem certeza que deseja ativar o cadastro';
  }

  openRegisterCadastroModalFromDropdown(): void {
    if (!this.getRegisterUuidForRegistersApi()) return;
    this.showCtaOptions = false;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems =
      this.getRegisterPapersForActivationFromApproval().map((p) => ({
        label: p.label,
        value: p.id,
      }));
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
    this.showRegisterCadastroModal = true;
    this.cdr.detectChanges();
  }

  closeRegisterCadastroModal(): void {
    this.showRegisterCadastroModal = false;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems = [];
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
    this.cdr.detectChanges();
  }

  async confirmRegisterCadastroStatusChange(): Promise<void> {
    const item = this.approval;
    if (!item?.register) return;

    const registerUuid = this.getRegisterUuidForRegistersApi();
    if (!registerUuid) {
      this.toast.show(
        'error',
        'Erro',
        'Não foi possível identificar o UUID do cadastro.',
      );
      return;
    }
    const isInactivating = this.isCurrentRegisterActive();
    const active = !isInactivating;

    let paperIdsToActivate: string[] = [];
    if (!isInactivating) {
      const papers = this.getRegisterPapersRawFromApproval();
      if (papers.length === 0) {
        this.toast.show(
          'error',
          'Erro',
          'Nenhum papel encontrado para este cadastro.',
        );
        return;
      }
      if (papers.length === 1) {
        const id = papers[0]?.id != null ? String(papers[0].id).trim() : '';
        if (!id) {
          this.toast.show(
            'error',
            'Erro',
            'Dados insuficientes para ativar o cadastro.',
          );
          return;
        }
        paperIdsToActivate = [id];
      } else {
        if (this.registerActivateAllPapers) {
          paperIdsToActivate = papers
            .map((p: any) => (p?.id != null ? String(p.id).trim() : ''))
            .filter(Boolean);
        } else {
          const raw = this.registerActivatePapersForm.get('paperIds')?.value;
          const ids = Array.isArray(raw) ? raw : [];
          paperIdsToActivate = ids.map((id) => String(id).trim()).filter(Boolean);
        }
        if (paperIdsToActivate.length === 0) {
          return;
        }
      }
    }

    this.closeRegisterCadastroModal();
    this.registerCadastroStatusSubmitting = true;

    try {
      if (isInactivating) {
        await this.api.patch({
          route: 'api/v3/registration/registers/',
          token: true,
          body: {
            register_uuid: registerUuid,
            active,
          },
        });
        this.toast.show('info', 'Sucesso', 'Cadastro inativado com sucesso.');
      } else {
        const paperResults = await Promise.all(
          paperIdsToActivate.map((paperId) =>
            this.api
              .patch({
                route: `api/v2/registration/registration-papers/${paperId}/`,
                token: true,
                body: { active: true },
              })
              .then(() => ({ ok: true as const }))
              .catch(() => ({ ok: false as const })),
          ),
        );
        const paperFailures = paperResults.filter((r) => !r.ok).length;
        if (paperFailures > 0) {
          this.toast.show(
            'warning',
            'Atenção',
            'Não foi possível concluir todas as ações.',
          );
        }
        try {
          await this.api.patch({
            route: 'api/v3/registration/registers/',
            token: true,
            body: {
              register_uuid: registerUuid,
              active: true,
            },
          });
          if (paperFailures === 0) {
            this.toast.show('info', 'Sucesso', 'Cadastro ativado com sucesso.');
          }
        } catch {
          this.toast.show(
            'error',
            'Erro',
            'Não foi possível alterar o status do cadastro. Tente novamente.',
          );
        }
      }

      await this.getApproval(this.approval?.version_number ?? null);
    } catch {
      if (isInactivating) {
        this.toast.show(
          'error',
          'Erro',
          'Não foi possível alterar o status do cadastro. Tente novamente.',
        );
      }
    } finally {
      this.registerCadastroStatusSubmitting = false;
      this.cdr.detectChanges();
    }
  }

  getPhone(item: UserApprovalResponse) {
    if (item.register.type.toUpperCase() === 'PF') {
      return item.register.person.cellphone.number;
    }

    if (item.register.type.toUpperCase() === 'PJ') {
      return item.register.company.cellphone.number;
    }

    return '';
  }

  getSignerName(sign: UserApprovalSignature) {
    if (sign.register) {
      if (sign.register.type.toUpperCase() === 'PF') {
        return sign.register.person.full_name;
      }

      if (sign.register.type.toUpperCase() === 'PJ') {
        return sign.register.company.corporate_name;
      }
    } else {
      if (sign.user) {
        return sign.user.name;
      }
      return 'Usuário não encontrado';
    }
  }

  handleRepresentativeSign() {
    if (!this.representativeSignId) {
      this.showRepresentativeSignErrorModal = true;
      return;
    }

    this.showRepresentativeSignModal = true;
  }

  closeRepresentativeSignModal() {
    this.showRepresentativeSignModal = false;
  }

  closeRepresentativeSignErrorModal() {
    this.showRepresentativeSignErrorModal = false;
  }

  closeValidationModal() {
    this.showValidationModal = false;
  }

  // Helper methods for modal content
  getValidationModalTitle() {
    return 'Valide os dados';
  }

  getValidationModalMessage() {
    return 'Verifique se os dados estão corretos e clique em "Assinar como representante" para prosseguir com a aprovação.';
  }

  getValidationConfirmText() {
    return 'Validar dados';
  }

  getFileApprovalModalTitle() {
    return 'Aprovar documento';
  }

  getFileApprovalModalMessage() {
    return 'Deseja aprovar este documento?';
  }

  getFileApprovalConfirmText() {
    return 'Sim';
  }

  getFileApprovalCancelText() {
    return 'Não';
  }

  getFileRejectionModalTitle() {
    return 'Reprovar documento';
  }

  getFileRejectionModalMessage() {
    return 'Deseja reprovar este documento?';
  }

  getFileRejectionConfirmText() {
    return 'Sim';
  }

  getFileRejectionCancelText() {
    return 'Não';
  }

  getRepresentativeSignModalTitle() {
    return 'Confirmação';
  }

  getRepresentativeSignModalMessage() {
    return 'É necessário que realize a assinatura digital para avançar para a etapa de aprovação';
  }

  getRepresentativeSignConfirmText() {
    return 'Assinar';
  }

  getRepresentativeSignCancelText() {
    return 'Cancelar';
  }

  getRepresentativeSignErrorTitle() {
    return 'Erro';
  }

  getRepresentativeSignErrorMessage() {
    return 'Não é possível assinar o cadastro, pois sua solicitação de assinatura não foi encontrada.';
  }

  getRepresentativeSignErrorConfirmText() {
    return 'OK';
  }

  getFileApprovalSuccessTitle() {
    return 'Sucesso';
  }

  getFileApprovalSuccessMessage() {
    return 'Documento aprovado com sucesso';
  }

  getFileApprovalSuccessConfirmText() {
    return 'OK';
  }

  getFileApprovalErrorTitle() {
    return 'Erro';
  }

  getFileApprovalErrorMessage() {
    return 'Erro ao aprovar documento';
  }

  getFileApprovalErrorConfirmText() {
    return 'OK';
  }

  // Helper methods for edit warning modal
  getEditWarningModalTitle() {
    return 'Atenção! Cadastro já aprovado';
  }

  getEditWarningModalMessage() {
    return 'Ao editar e reenviar, o cadastro voltará para aprovação.';
  }

  getEditWarningConfirmText() {
    return 'Sim, editar!';
  }

  getEditWarningCancelText() {
    return 'Cancelar';
  }

  async confirmRepresentativeSign() {
    this.representativeSigning = true;
    try {
      if (!this.representativeSignId) {
        this.showRepresentativeSignErrorModal = true;
        return;
      }

      const register_uuid = this.route?.snapshot?.params?.id;
      await this.api.patch({
        route: `api/registration/registration-sign-status/${this.representativeSignId}/`,
        params: { register_uuid },
        body: { has_signed: true },
        token: true,
      });

      this.representativeHasSigned = true;
      const list =
        this.approvalService.approvalData.representativeSignStatus || [];
      const updatedList = list.map((item: any) =>
        item?.id === this.representativeSignId
          ? { ...item, has_signed: true }
          : item,
      );
      this.approvalService.approvalData.representativeSignStatus = updatedList;

      const signRequired = updatedList.filter(
        (item: any) => item?.signs_registration_form,
      );
      const representativeSignStatus = {
        total: signRequired.length,
        signed: signRequired.filter((item: any) => item?.has_signed).length,
      };

      if (this.approval) {
        (this.approval as any).representative_sign_status =
          representativeSignStatus;
      }
      this.approvalService.updateRepresentativeSignStatus.emit();

      this.closeRepresentativeSignModal();
      this.toast.show('info', 'Sucesso!', 'Assinado com sucesso');
    } catch (error) {
      this.closeRepresentativeSignModal();
      this.showRepresentativeSignErrorModal = true;
    } finally {
      this.representativeSigning = false;
    }
  }

  /**
   * Determina se o usuário é Master baseado nas regras:
   * - type_permission === "master" OU type_permission === "owner" OU is_approver === true
   */
  isMasterUser(): boolean {
    const user = this.authService.user || this.authService.getUser();
    if (!user) {
      return false;
    }
    // Verificação: type_permission === "master" OU type_permission === "owner" OU is_approver === true
    return (
      user.type_permission === 'master' ||
      user.type_permission === 'owner' ||
      user.is_approver === true
    );
  }

  /**
   * Verifica se os botões de aprovação devem estar sempre habilitados
   * Retorna true se o usuário for Master e o cadastro estiver em aprovação
   */
  shouldAlwaysEnableApprovalButtons(): boolean {
    return this.isMasterUser() && this.isInApproval();
  }

  /**
   * Verifica se o registro é cotista (shareholder)
   * Verifica primeiro no array roles, depois no role único
   * @returns true se o registro é cotista
   */
  isShareholder(): boolean {
    if (!this.approval || !this.approval.register) {
      return false;
    }

    const register = this.approval.register;

    // Verificar primeiro no array de roles (múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      return register.roles.some(
        (role: any) => role?.applicable === 'shareholder',
      );
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    return register.role?.applicable === 'shareholder';
  }

  /**
   * Verifica se o usuário é cotista, cedente ou prestador de serviço
   * Retorna true se for um desses 3 tipos de perfil
   */
  isAssignorProviderOrShareholder(): boolean {
    const user = this.authService.user || this.authService.getUser();
    if (!user || !user.active_register) {
      return false;
    }

    const activeRegister = user.active_register.register;
    const roleApplicable = activeRegister.role?.applicable;

    // Verifica se é cotista, cedente ou prestador de serviço
    return (
      roleApplicable === 'shareholder' ||
      roleApplicable === 'assignor' ||
      roleApplicable === 'provider'
    );
  }

  /**
   * Verifica se o usuário atual é Master OU Colaborador Comum
   * Usado no template para controlar exibição de elementos (botões de aprovação, etc)
   */
  isMasterOrCommonUser(): boolean {
    return (
      this.authService.isMasterUser() || this.authService.isCommonCollaborator()
    );
  }

  /**
   * Verifica se o usuário é Colaborador Comum (usando a mesma lógica do header)
   */
  isCommonUser(): boolean {
    return this.authService.isCommonCollaborator();
  }

  setPermissions() {
    const permissions = Object.keys(this.permissionObj).map(
      (key) => `de_can_${key.split('can').join('').toLowerCase()}_${this.role}`,
    );

    // Verificar se é owner ou master
    const permissionType = this.storageService.getPermissionType();
    const isOwnerOrMaster =
      permissionType === 'owner' || permissionType === 'master';
    const isSuperuser = this.authService.user?.is_superuser || false;

    permissions.forEach((permission, idx) => {
      const key = Object.keys(this.permissionObj)[idx];
      const hasPermission = this.authService.verifyPermission(permission);

      // Se for owner, master ou superuser, permitir aprovação mesmo sem a permissão específica
      if (key === 'canApprove' && (isOwnerOrMaster || isSuperuser)) {
        this.permissionObj[key] = true;
      } else {
        this.permissionObj[key] = hasPermission;
      }
    });
  }

  renderLink() {
    return '';
  }

  toggleShowOptions() {
    this.showCtaOptions = !this.showCtaOptions;
  }

  toggleVersionsOptions() {
    this.showVersionsOptions = !this.showVersionsOptions;
  }

  async compareVersions() {
    this.showVersionsOptions = false;
    if (this.comparingVersions) {
      // Parar de comparar versões - voltar ao modo normal
      this.comparingVersions = false;
      // Limpar seleções de versões
      this.selectedLeftVersion = null;
      this.selectedRightVersion = null;
      this.approvalService.approvalData.mainRevision = null;
      this.approvalService.approvalData.mainVersion = null;
      this.approvalService.approvalData.comparingRevision = null;
      this.approvalService.approvalData.comparingVersion = null;

      // Recarregar as abas para que "Documentos Internos" volte a aparecer
      if (this.approval) {
        this.handleSetTabs(this.approval);
      }

      // Voltar para a versão principal (mais atual) mantendo a aba atual
      if (this.allApprovals && this.allApprovals.length > 0) {
        const latestVersion = this.allApprovals[0]; // Já está ordenado por versão mais alta
        this.changeApproval(latestVersion, true); // true = preservar aba atual
      }
    } else {
      // Se estiver na aba "Documentos Internos", redirecionar para "Dados básicos"
      if (this.activedTab === 'internal-documents') {
        this.activedTab = 'complementary';
        this.tabIndex = this.tabs.findIndex(
          (tab) => tab.value === 'complementary',
        );
        this.approvalService.approvalData.activeTab = 'complementary';
      }

      // Desativar seletor de versões se estiver ativo
      this.showVersionSelector = false;
      this.selectedVersion = null;
      // Ativar modo de comparação
      this.comparingVersions = true;

      // Recarregar as abas para remover "Documentos Internos"
      if (this.approval) {
        this.handleSetTabs(this.approval);
      }

      // Carregar versões da API v3 quando entrar no modo de comparação
      await this.loadVersionsFromV3();
    }
  }

  async viewAllVersions() {
    this.showVersionsOptions = false;

    if (this.showVersionSelector) {
      // Se já estiver ativo, desativar e voltar para a versão principal
      this.closeVersionSelector();
    } else {
      // Ativar loading
      this.loadingViewAllVersions = true;

      try {
        // Desativar modo comparando se estiver ativo
        if (this.comparingVersions) {
          this.comparingVersions = false;
          this.selectedLeftVersion = null;
          this.selectedRightVersion = null;
          this.approvalService.approvalData.mainRevision = null;
          this.approvalService.approvalData.mainVersion = null;
          this.approvalService.approvalData.comparingRevision = null;
          this.approvalService.approvalData.comparingVersion = null;
        }
        // Guardar a versão principal antes de entrar no modo visualizar todas
        if (this.approval && this.allApprovals) {
          const mainVersion = this.allApprovals.find(
            (v) => v.version_number === this.approval.version_number,
          );
          if (mainVersion) {
            this.approvalService.approvalData.originalVersion =
              mainVersion.version_number;
            this.approvalService.approvalData.originalRevision =
              mainVersion.revision;
          }
        }
        // Buscar versões da API v3
        await this.loadVersionsFromV3();
        // Ativar seletor de versões
        this.showVersionSelector = true;
        // Se não houver versão selecionada, definir a versão atual como padrão
        if (!this.selectedVersion && this.approval) {
          this.selectedVersion =
            this.allApprovals?.find(
              (v) => v.version_number === this.approval.version_number,
            ) || null;
        }
      } finally {
        // Desativar loading
        this.loadingViewAllVersions = false;
      }
    }
  }

  /**
   * Busca versões da API v3 usando list_versions=true
   */
  async loadVersionsFromV3() {
    try {
      const register_uuid = this.route.snapshot.params.id;

      if (!register_uuid) {
        return;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: {
          list_versions: true,
        },
        token: true,
      });

      if (response && response.data && response.data.versions) {
        // Mapear versões da API v3 para o formato esperado
        const versions = response.data.versions.map((v: any) => ({
          version_number: v.version_number,
          id: v.id,
          revision: v.id, // Usar id como revision
          created_at: v.created_at,
          is_approved: v.is_approved,
          completed: v.completed,
          homologated: v.homologated,
          step: v.step,
          status: v.status,
          status_label: v.status_label,
          is_draft: v.is_draft || false,
          valid_until: v.valid_until || null,
        }));

        // Ordenar por versão mais alta primeiro
        this.allApprovals = versions.sort(
          (a, b) => b.version_number - a.version_number,
        );
      }
    } catch (error) {
      console.error('[DashboardApproval] loadVersionsFromV3 - ERRO:', error);
    }
  }

  /**
   * Chama a API de reprocess-snapshot (apenas uma vez)
   */
  async callReprocessSnapshot() {
    try {
      const register_uuid = this.route.snapshot.params.id;

      if (!register_uuid || this.reprocessSnapshotCalled) {
        return;
      }

      await this.api.post<any>({
        route: `api/v3/registration/versions/reprocess-snapshot/register/${register_uuid}/`,
        body: {},
        token: true,
      });

      this.reprocessSnapshotCalled = true;
      console.log(
        '[DashboardApproval] callReprocessSnapshot - API chamada com sucesso',
      );
    } catch (error) {
      console.error('[DashboardApproval] callReprocessSnapshot - ERRO:', error);
      // Se der erro (ex: approval não tem version_data), liberar o botão de editar
      this.versioningIsComplete = true;
      this.reprocessSnapshotCalled = true; // Marcar como chamado para não tentar novamente
      this.cdr.detectChanges();
    }
  }

  /**
   * Busca dados de versionamento usando versioning_status=true&last=true
   * Faz polling a cada 10 segundos enquanto is_complete for false
   */
  async loadVersioningData() {
    try {
      const register_uuid = this.route.snapshot.params.id;

      if (!register_uuid) {
        console.warn(
          '[DashboardApproval] loadVersioningData - Register UUID não encontrado',
        );
        return;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: {
          versioning_status: true,
          last: true,
        },
        token: true,
      });

      if (response && response.data) {
        this.versioningData = response.data;
        const previousIsComplete = this.versioningIsComplete;

        // Se não houver version_data, tratar como completo para liberar o botão de editar
        // (approval não foi criado com sistema de versionamento v3)
        if (!response.data.version_data) {
          this.versioningIsComplete = true;
          this.versioningProgress = null;
          // Parar o polling
          if (this.versioningInterval) {
            clearInterval(this.versioningInterval);
            this.versioningInterval = null;
          }
          this.reprocessSnapshotCalled = true; // Marcar como chamado para não tentar reprocess
          this.cdr.detectChanges();
          return;
        }

        this.versioningIsComplete = response.data.is_complete === true;
        this.versioningProgress = response.data.versioning_progress || null;

        // Se não estiver completo
        if (!this.versioningIsComplete) {
          // Chamar API de reprocess-snapshot apenas uma vez (quando detectar que não está completo)
          if (!this.reprocessSnapshotCalled) {
            this.callReprocessSnapshot();
          }

          // Limpar intervalo anterior se existir
          if (this.versioningInterval) {
            clearInterval(this.versioningInterval);
          }

          // Criar novo intervalo de 10 segundos para continuar verificando
          this.versioningInterval = setInterval(() => {
            this.loadVersioningData();
          }, 10000);
        } else {
          // Se estiver completo, limpar intervalo e resetar flag
          if (this.versioningInterval) {
            clearInterval(this.versioningInterval);
            this.versioningInterval = null;
          }
          // Resetar flag quando completar para permitir nova chamada se necessário
          this.reprocessSnapshotCalled = false;
        }

        // Forçar detecção de mudanças para atualizar a UI
        this.cdr.detectChanges();
      } else {
        // Se não houver data na resposta, liberar o botão de editar
        this.versioningIsComplete = true;
        if (this.versioningInterval) {
          clearInterval(this.versioningInterval);
          this.versioningInterval = null;
        }
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('[DashboardApproval] loadVersioningData - ERRO:', error);
      // Em caso de erro (ex: approval não tem version_data), liberar o botão de editar
      this.versioningIsComplete = true;
      // Parar o polling
      if (this.versioningInterval) {
        clearInterval(this.versioningInterval);
        this.versioningInterval = null;
      }
      // Forçar detecção de mudanças para atualizar a UI
      this.cdr.detectChanges();
    }
  }

  selectLeftVersion(version: VersionProps) {
    this.selectedLeftVersion = version;
    this.showLeftVersions = false;
    this.approvalService.approvalData.mainRevision = version.revision;
    this.approvalService.approvalData.mainVersion = version.version_number;

    // Se houver versão de comparação selecionada e ela for menor que a nova versão principal, resetar
    if (
      this.selectedRightVersion &&
      this.selectedRightVersion.version_number < version.version_number
    ) {
      this.selectedRightVersion = null;
      this.approvalService.approvalData.comparingRevision = null;
      this.approvalService.approvalData.comparingVersion = null;
    }

    // Garantir que a aba ativa está atualizada no service
    this.approvalService.approvalData.activeTab = this.activedTab;
    this.approvalService.changeMainVersion.emit();
  }

  selectRightVersion(version: VersionProps) {
    this.selectedRightVersion = version;
    this.showRightVersions = false;
    this.approvalService.approvalData.comparingRevision = version.revision;
    this.approvalService.approvalData.comparingVersion = version.version_number;
    // Garantir que a aba ativa está atualizada no service
    this.approvalService.approvalData.activeTab = this.activedTab;
    this.approvalService.changeComparingVersion.emit();
  }

  async handleGetAcessToAccount() {
    const uudi = this.route.snapshot.params.id;
    let id: number;

    const foundedRegister = this.authService.accountsArr.find((account) => {
      return account.register.id === uudi;
    });

    if (!foundedRegister) {
      try {
        const res = await this.api.post({
          route: 'api/registration/request/register',
          body: { register_id: uudi },
          token: true,
        });

        id = res.data.id;
      } catch (error) {
        this.toast.show(
          'error',
          'Erro!',
          'Erro ao solicitar acesso a conta ativa',
        );
      }
    } else {
      id = foundedRegister.id;
    }

    await this.api.patch({
      route: `user/me/`,
      token: true,
      body: {
        active_register: id,
      },
    });

    const { data } = await this.api.get<ApiResponse<NewLoginResponse>>({
      route: 'user/me/',
      token: true,
    });

    this.authService.setUser(data);

    // this.storageService.setPermissionType(data.type_permission);

    // let permissionsArr =
    //   data.active_register.permissions_role &&
    //   data.active_register.permissions_role.permissions
    //     ? data.active_register.permissions_role.permissions
    //     : [];

    // if (data.type_permission === 'owner') permissionsArr = permission;

    // this.authService.permissions = permissionsArr;
    // this.storageService.set('permissions', permissionsArr, true);
  }

  formatDateTime(date: string) {
    return new Date(date).toLocaleString('pt-BR');
  }

  formatDate(date: string) {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  getVersionText(approval: UserApprovalResponse): string {
    if (!approval) return '';

    // Se estiver no modo "visualizar todas" e houver versão selecionada, mostrar a versão selecionada
    if (this.showVersionSelector && this.selectedVersion) {
      // Verificar se a versão selecionada é a última versão (primeira do array ordenado)
      const isLatest =
        this.allApprovals &&
        this.allApprovals.length > 0 &&
        this.selectedVersion.version_number ===
          this.allApprovals[0].version_number;
      return `Versão ${this.selectedVersion.version_number}${
        isLatest ? ' (Atual)' : ''
      }`;
    }

    // Se não estiver no modo "visualizar todas", mostrar a versão do approval
    const versionNumber = approval.version_number;

    // Verificar se é a última versão
    if (this.allApprovals && this.allApprovals.length > 0) {
      const latestVersion = this.allApprovals[0];
      const isLatest = versionNumber === latestVersion.version_number;
      return `Versão ${versionNumber}${isLatest ? ' (Atual)' : ''}`;
    }

    // Se não houver allApprovals, assumir que é atual
    return `Versão ${versionNumber} (Atual)`;
  }

  async changeApproval(approval: VersionProps, preserveTab: boolean = false) {
    this.showOptions = false;

    this.loading = true;
    this.signing = true;

    // Só reseta a aba se não for para preservar
    if (!preserveTab) {
      this.activedTab = 'complementary';
      this.tabIndex = 0;
      this.approvalService.approvalData.activeTab = 'complementary';
    }

    this.approvalService.reset();
    this.approvalService.approvalData.version = approval.version_number;
    this.approvalService.changeVersion.emit();
    this.getApproval(approval.version_number);
  }

  async selectVersion(version: VersionProps) {
    this.selectedVersion = version;
    this.showVersionDropdown = false;

    // Salvar a versão selecionada no service ANTES de emitir o evento
    // para que os componentes filhos já tenham a versão correta ao receber o evento
    this.approvalService.approvalData.version = version.version_number;

    // Garantir que a aba ativa está atualizada no service
    this.approvalService.approvalData.activeTab = this.activedTab;

    // Ativar loading do header ANTES de emitir o evento
    this.loadingHeaderVersion = true;

    // Emitir evento PRIMEIRO para os componentes filhos começarem a carregar
    // Os componentes filhos vão fazer suas próprias chamadas com todos os data_type
    // (complementary, address, bank_information, professional, representatives, etc)
    this.approvalService.changeVersion.emit();

    // Depois, buscar dados do header (nome, status, etc) da API v3
    try {
      const versionApproval = await this.getApprovalFromV3(
        version.version_number,
      );

      if (versionApproval) {
        // Atualizar o objeto approval com os dados da versão selecionada
        this.approval = versionApproval;
      }
    } catch (error) {
    } finally {
      // Desativar loading do header
      this.loadingHeaderVersion = false;
    }
  }

  async toggleVersionDropdown() {
    if (!this.showVersionDropdown) {
      // Sempre carregar versões da API v3 quando abrir o dropdown
      this.loadingVersions = true;
      this.showVersionDropdown = true;
      try {
        await this.loadVersionsFromV3();
      } catch (error) {
      } finally {
        this.loadingVersions = false;
      }
    } else {
      this.showVersionDropdown = false;
    }
  }

  async toggleLeftVersionsDropdown() {
    if (!this.showLeftVersions) {
      // Sempre carregar versões da API v3 quando abrir o dropdown no modo de comparação
      this.loadingLeftVersions = true;
      this.showLeftVersions = true;
      try {
        await this.loadVersionsFromV3();
      } catch (error) {
      } finally {
        this.loadingLeftVersions = false;
      }
    } else {
      this.showLeftVersions = false;
    }
  }

  async toggleRightVersionsDropdown() {
    // Não permitir abrir se não houver versão principal selecionada
    if (!this.selectedLeftVersion) {
      return;
    }

    if (!this.showRightVersions) {
      // Sempre carregar versões da API v3 quando abrir o dropdown no modo de comparação
      this.loadingRightVersions = true;
      this.showRightVersions = true;
      try {
        await this.loadVersionsFromV3();
      } catch (error) {
      } finally {
        this.loadingRightVersions = false;
      }
    } else {
      this.showRightVersions = false;
    }
  }

  /**
   * Retorna apenas as versões disponíveis para comparação (>= versão principal)
   */
  getAvailableComparisonVersions(): VersionProps[] {
    if (!this.allApprovals || !this.selectedLeftVersion) {
      return [];
    }

    const principalVersionNumber = this.selectedLeftVersion.version_number;

    // Filtrar versões >= versão principal
    return this.allApprovals.filter(
      (version) => version.version_number >= principalVersionNumber,
    );
  }

  /**
   * Verifica se uma versão é a versão atual (comparando com approval.version_number)
   */
  isCurrentVersion(version: VersionProps): boolean {
    if (!version || !this.allApprovals || this.allApprovals.length === 0)
      return false;
    // A última versão é a primeira do array ordenado (versão mais alta)
    const latestVersion = this.allApprovals[0];
    return version.version_number === latestVersion.version_number;
  }

  /**
   * Obtém a classe CSS do badge baseado no status da versão
   */
  getStatusBadgeClass(version: VersionProps): string {
    if (!version) return 'status-badge-editing';

    // Se tiver status_label, usar ele para determinar a classe
    if (version.status_label) {
      const label = version.status_label.toLowerCase();
      if (label.includes('homologado') || label.includes('homologada')) {
        return 'status-badge-homologated';
      } else if (label.includes('aprovado') || label.includes('aprovada')) {
        return 'status-badge-homologated'; // Aprovado também usa verde
      } else if (label.includes('rejeitado') || label.includes('rejeitada')) {
        return 'status-badge-rejected';
      } else if (label.includes('aprovação') || label.includes('aprovacao')) {
        return 'status-badge-approval';
      } else if (label.includes('edição') || label.includes('edicao')) {
        return 'status-badge-editing';
      }
    }

    // Fallback: usar status se disponível
    if (version.status) {
      if (version.status === 'homologated') {
        return 'status-badge-homologated';
      } else if (version.status === 'approved') {
        return 'status-badge-homologated';
      } else if (version.status === 'rejected') {
        return 'status-badge-rejected';
      } else if (version.status === 'pending') {
        return 'status-badge-approval';
      } else if (version.status === 'editing') {
        return 'status-badge-editing';
      }
    }

    // Fallback final: usar lógica baseada em completed, is_approved, homologated
    if (version.completed) {
      if (version.homologated) {
        return 'status-badge-homologated';
      } else if (version.is_approved) {
        return 'status-badge-homologated';
      } else {
        return 'status-badge-rejected';
      }
    }

    if (version.step === 0 || version.step === null) {
      return 'status-badge-editing';
    }

    return 'status-badge-approval';
  }

  /**
   * Obtém o texto do status para exibição
   */
  getStatusLabel(version: VersionProps): string {
    if (!version) return 'Em edição';

    if (version.status_label) {
      return version.status_label;
    }

    // Fallback: usar status se disponível
    if (version.status) {
      const statusMap: { [key: string]: string } = {
        homologated: 'Homologado',
        approved: 'Aprovado',
        rejected: 'Rejeitado',
        pending: 'Em aprovação',
        editing: 'Em edição',
      };
      return statusMap[version.status] || 'Em edição';
    }

    // Fallback final: usar lógica baseada em completed, is_approved, homologated
    if (version.completed) {
      if (version.homologated) {
        return 'Homologado';
      } else if (version.is_approved) {
        return 'Aprovado';
      } else {
        return 'Rejeitado';
      }
    }

    // Se a versão não tem status definido, verificar o status do cadastro (register.current_stage)
    // Isso resolve o problema quando o backend retorna "version 1" mas o cadastro está homologado
    // Verificar antes de usar step === 0, para priorizar o status geral do cadastro
    if (!version.status && !version.status_label && !version.completed) {
      if (this.approval?.register?.current_stage) {
        const currentStage = this.approval.register.current_stage;

        // Se o cadastro está homologado/aprovado, a versão também deve mostrar isso
        // (mesmo que step === 0, pois pode ser uma versão padrão do backend)
        if (
          currentStage === 'Homologado' ||
          currentStage === 'Aprovado' ||
          currentStage === 'Concluído'
        ) {
          return 'Homologado';
        }

        // Se o cadastro está em aprovação, a versão também deve mostrar isso
        if (
          currentStage === 'Em aprovação' ||
          currentStage === 'Em aprovacao'
        ) {
          return 'Em aprovação';
        }

        // Se o cadastro está rejeitado, a versão também deve mostrar isso
        if (currentStage === 'Rejeitado') {
          return 'Rejeitado';
        }
      }
    }

    // Verificar step apenas se não encontrou status em nenhuma das verificações anteriores
    if (version.step === 0 || version.step === null) {
      return 'Em edição';
    }

    return 'Em aprovação';
  }

  closeVersionSelector() {
    this.showVersionSelector = false;
    this.selectedVersion = null;

    // Limpar versão selecionada do approvalService para voltar a usar last=true
    this.approvalService.approvalData.version = null;

    // Voltar para a versão principal que foi guardada no service
    if (
      this.approvalService.approvalData.originalVersion !== null &&
      this.allApprovals
    ) {
      const originalVersion = this.allApprovals.find(
        (v) =>
          v.version_number ===
          this.approvalService.approvalData.originalVersion,
      );
      if (originalVersion) {
        this.changeApproval(originalVersion);
      }
      // Limpar a versão original guardada
      this.approvalService.approvalData.originalVersion = null;
      this.approvalService.approvalData.originalRevision = null;
    } else if (this.allApprovals && this.allApprovals.length > 0) {
      // Fallback: se não houver versão principal guardada, usar a mais atual
      const latestVersion = this.allApprovals[0]; // Já está ordenado por versão mais alta
      this.changeApproval(latestVersion);
    }
  }

  // Métodos para perfis de cotista usando dados reais da API
  getRiskLevelConfig(riskLevel: string) {
    const normalized = (riskLevel || '').toString().toLowerCase();
    const configs = {
      high: {
        type: 'Agressivo',
        // fallback: usar total_days (calculado via API) quando existir
        duration: 180, // dias
        badgeTextColor: '#A2191F',
        badgeBackgroundColor: '#FFD7D9',
      },
      medium: {
        type: 'Moderado',
        duration: 365, // dias
        badgeTextColor: '#0043CE',
        badgeBackgroundColor: '#D0E2FF',
      },
      low: {
        type: 'Conservador',
        duration: 730, // dias
        badgeTextColor: '#0E6027',
        badgeBackgroundColor: '#A7F0BA',
      },
    };
    return configs[normalized] || configs.medium; // Default para medium se não encontrar
  }

  // Método para configuração de "Não declarado"
  getNotDeclaredConfig() {
    return {
      type: 'Não declarado',
      duration: 0,
      badgeTextColor: '#4c4c4c',
      badgeBackgroundColor: '#ebebeb',
    };
  }

  getExemptInvestorProfileConfig() {
    return {
      type: 'DISPENSA POR NORMA CONF. ICVM 30, ART. 10 itens II, III ou IV',
      duration: 0,
      badgeTextColor: '#525252',
      badgeBackgroundColor: '#e0e0e0',
    };
  }

  getCurrentProfile() {
    if (this.isExempt()) {
      const c = this.getExemptInvestorProfileConfig();
      return {
        type: c.type,
        duration: 0,
        daysRemaining: 0,
        daysRemainingReal: 0,
        expired: false,
        badgeTextColor: c.badgeTextColor,
        badgeBackgroundColor: c.badgeBackgroundColor,
      };
    }

    // Verificar primeiro se é "não declarado"
    if (this.isNotDeclared()) {
      return {
        type: 'Não declarado',
        duration: 0,
        daysRemaining: 0,
        daysRemainingReal: 0,
        expired: false,
        badgeTextColor: '#4c4c4c',
        badgeBackgroundColor: '#ebebeb',
      };
    }

    if (
      !this.registrationExpirationInfo ||
      !this.registrationExpirationInfo?.risk_level
    ) {
      // Fallback para dados padrão se não houver dados da API
      return {
        type: 'Moderado',
        duration: 360,
        daysRemaining: 0,
        daysRemainingReal: 0,
        expired: false,
        badgeTextColor: '#0043CE',
        badgeBackgroundColor: '#D0E2FF',
      };
    }

    const riskLevel = this.registrationExpirationInfo?.risk_level;
    if (!riskLevel) {
      return {
        type: 'Moderado',
        duration: 360,
        daysRemaining: 0,
        daysRemainingReal: 0,
        expired: false,
        badgeTextColor: '#0043CE',
        badgeBackgroundColor: '#D0E2FF',
      };
    }

    const config = this.getRiskLevelConfig(riskLevel);
    const totalDaysFromApi =
      this.registrationExpirationInfo?.total_days !== undefined &&
      this.registrationExpirationInfo?.total_days !== null
        ? Number(this.registrationExpirationInfo.total_days)
        : null;
    const daysRemainingReal =
      this.registrationExpirationInfo?.days_until_expiration || 0;
    const expired = this.registrationExpired || false;

    return {
      type: config.type,
      duration:
        totalDaysFromApi &&
        !Number.isNaN(totalDaysFromApi) &&
        totalDaysFromApi > 0
          ? totalDaysFromApi
          : config.duration,
      daysRemaining: Math.abs(daysRemainingReal), // Valor absoluto para exibição
      daysRemainingReal: daysRemainingReal, // Valor real para cálculos
      expired: expired,
      badgeTextColor: config.badgeTextColor,
      badgeBackgroundColor: config.badgeBackgroundColor,
    };
  }

  getProfileProgress(): number {
    if (this.isExempt()) {
      return 0;
    }

    if (
      !this.registrationExpirationInfo ||
      !this.registrationExpirationInfo?.risk_level
    ) {
      return 0;
    }

    const profile = this.getCurrentProfile();
    if (!profile) {
      return 0;
    }

    if (profile.expired) {
      return 100; // 100% quando expirado
    }

    // Calcula o progresso baseado na duração total e dias restantes (quanto menos dias falta, mais preenchido)
    const totalDays = profile.duration;
    const daysRemaining = profile.daysRemainingReal; // Usar valor real para cálculo correto
    const usedDays = totalDays - daysRemaining;
    const progress = Math.round((usedDays / totalDays) * 100);

    // Garantir que o progresso está entre 0 e 100
    return Math.max(0, Math.min(100, progress));
  }

  isNotDeclared(): boolean {
    if (!this.registrationExpirationInfo) {
      return false;
    }
    return (
      this.registrationExpirationInfo?.raw?.not_declared === true ||
      this.registrationExpirationInfo?.not_declared === true
    );
  }

  isExempt(): boolean {
    if (!this.registrationExpirationInfo) {
      return false;
    }
    return (
      this.registrationExpirationInfo?.raw?.is_exempt === true ||
      this.registrationExpirationInfo?.is_exempt === true
    );
  }

  getExpirationText(): string {
    if (!this.registrationExpirationInfo) {
      return '';
    }

    if (this.isExempt()) {
      return '';
    }

    // Se for "não declarado", não retornar texto (o badge já mostra)
    if (this.isNotDeclared()) {
      return '';
    }

    const profile = this.getCurrentProfile();
    if (!profile) {
      return '';
    }

    if (profile.expired) {
      return 'Expirado';
    }

    return `Expira em ${profile.daysRemaining} dias`;
  }

  async checkRegistrationExpiration() {
    // Esse badge só aparece para Cotista (shareholder)
    // Verificar primeiro no array de roles (múltiplos papéis)
    let isShareholder = false;

    if (
      this.approval?.register?.roles &&
      Array.isArray(this.approval.register.roles) &&
      this.approval.register.roles.length > 0
    ) {
      isShareholder = this.approval.register.roles.some(
        (role: any) => role?.applicable === 'shareholder',
      );
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    if (!isShareholder) {
      isShareholder =
        this.approval?.register?.role?.applicable === 'shareholder';
    }

    if (!isShareholder) {
      if (this.registrationExpired !== undefined) {
        this.registrationExpired = false;
      }
      if (this.registrationExpirationInfo !== undefined) {
        this.registrationExpirationInfo = null;
      }
      return;
    }

    const register_uuid = this.route?.snapshot?.params?.id;
    if (!register_uuid) {
      if (this.registrationExpired !== undefined) {
        this.registrationExpired = false;
      }
      if (this.registrationExpirationInfo !== undefined) {
        this.registrationExpirationInfo = null;
      }
      return;
    }

    // PF vs PJ para cotista
    const registerType = this.approval?.register?.type?.toUpperCase() || 'PF';
    const dataType =
      registerType === 'PJ' ? 'investor_profile_pj' : 'investor_profile_pf';

    // Respeitar versão selecionada (quando existir) senão usar last=true
    const params: any = { data_type: dataType };
    if (this.approvalService?.approvalData?.version) {
      params.version = this.approvalService.approvalData.version;
    } else {
      params.last = true;
    }

    try {
      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params,
        token: true,
      });

      // Estrutura esperada:
      // response.data.versions[dataType].versions[0].data -> objeto InvestorProps (ou array)
      const investorProfileData =
        response?.data?.versions?.[dataType]?.versions?.[0]?.data || null;

      const entries = Array.isArray(investorProfileData)
        ? investorProfileData
        : investorProfileData
          ? [investorProfileData]
          : [];

      // Escolher o mais recente (fallback por id/start_date)
      const latest = entries.filter(Boolean).sort((a: any, b: any) => {
        const aDate = a?.start_date ? Date.parse(a.start_date) : NaN;
        const bDate = b?.start_date ? Date.parse(b.start_date) : NaN;
        if (!Number.isNaN(aDate) && !Number.isNaN(bDate)) return bDate - aDate;
        const aId = Number(a?.id || 0);
        const bId = Number(b?.id || 0);
        return bId - aId;
      })[0];

      if (!latest) {
        if (this.registrationExpired !== undefined) {
          this.registrationExpired = false;
        }
        if (this.registrationExpirationInfo !== undefined) {
          this.registrationExpirationInfo = null;
        }
        return;
      }

      // Mapear profile numérico -> risco:
      // 1 = Conservador (low), 2 = Moderado (medium), 3 = Agressivo (high)
      const profileNum =
        latest?.profile !== undefined && latest?.profile !== null
          ? Number(latest.profile)
          : null;
      const riskLevelFromProfile =
        profileNum === 1
          ? 'low'
          : profileNum === 2
            ? 'medium'
            : profileNum === 3
              ? 'high'
              : null;
      const riskLevel =
        riskLevelFromProfile ||
        (latest?.risk_profile || '').toString().toLowerCase() ||
        'medium';

      // days_to_expire é o "dias para expirar"
      let daysUntil: number | null =
        latest?.days_to_expire !== undefined && latest?.days_to_expire !== null
          ? Number(latest.days_to_expire)
          : null;

      let expireDate: Date | null = null;
      let calculatedDaysUntil: number | null = null;

      // Se não tiver days_to_expire da API, calcular baseado em start_date + duração do perfil
      if (daysUntil === null && latest?.start_date) {
        const startDate = new Date(latest.start_date);
        expireDate = new Date(startDate);

        // Calcular duração baseada no perfil
        if (profileNum === 1) {
          // Conservador: 2 anos
          expireDate.setFullYear(expireDate.getFullYear() + 2);
        } else if (profileNum === 2) {
          // Moderado: 1 ano
          expireDate.setFullYear(expireDate.getFullYear() + 1);
        } else if (profileNum === 3) {
          // Agressivo: 6 meses
          expireDate.setMonth(expireDate.getMonth() + 6);
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);

        const diffTime = expireDate.getTime() - today.getTime();
        calculatedDaysUntil = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        // Usar o valor calculado se não tiver da API
        if (daysUntil === null) {
          daysUntil = calculatedDaysUntil;
        }
      }

      // total_days = diferença entre start_date e validity (pra barra de progresso ficar correta)
      const startTs = latest?.start_date ? Date.parse(latest.start_date) : NaN;
      const validityTs = latest?.validity ? Date.parse(latest.validity) : NaN;
      let totalDays: number | null = null;

      if (!Number.isNaN(startTs) && !Number.isNaN(validityTs)) {
        totalDays = Math.max(
          1,
          Math.ceil((validityTs - startTs) / (1000 * 60 * 60 * 24)),
        );
        // Garantir que o total não fique menor que os dias restantes (evita barra negativa)
        if (typeof daysUntil === 'number' && !Number.isNaN(daysUntil)) {
          totalDays = Math.max(totalDays, Math.abs(daysUntil));
        }
      } else if (expireDate && latest?.start_date) {
        // Se não tiver validity, calcular total_days baseado na data de expiração calculada
        const startDate = new Date(latest.start_date);
        startDate.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);
        totalDays = Math.max(
          1,
          Math.ceil(
            (expireDate.getTime() - startDate.getTime()) /
              (1000 * 60 * 60 * 24),
          ),
        );
        if (typeof daysUntil === 'number' && !Number.isNaN(daysUntil)) {
          totalDays = Math.max(totalDays, Math.abs(daysUntil));
        }
      }

      if (this.registrationExpirationInfo !== undefined) {
        this.registrationExpirationInfo = {
          risk_level: riskLevel,
          days_until_expiration: daysUntil,
          total_days: totalDays,
          validity: latest?.validity,
          start_date: latest?.start_date,
          expire_date: expireDate ? expireDate.toISOString() : null,
          not_declared: latest?.not_declared === true,
          is_exempt: latest?.is_exempt === true,
          raw: latest,
        };
      }

      // Verificar se está expirado
      if (this.registrationExpired !== undefined) {
        if (latest?.is_exempt === true) {
          this.registrationExpired = false;
        } else {
          this.registrationExpired =
            latest?.is_expired === true ||
            daysUntil === null ||
            daysUntil === undefined ||
            (typeof daysUntil === 'number' && daysUntil < 0);
        }
      }
    } catch (error) {
      if (this.registrationExpired !== undefined) {
        this.registrationExpired = false;
      }
      if (this.registrationExpirationInfo !== undefined) {
        this.registrationExpirationInfo = null;
      }
    }
  }

  setBreadcrumb(): void {
    const canViewCadastros =
      this.authService?.verifyPermission('de_can_view_registers') || false;
    const registerId = this.route?.snapshot?.params?.id;

    // Tentar obter o nome do registro
    let registerName = 'Detalhes';
    if (this.approval?.register) {
      const register = this.approval.register;
      if (register.type?.toUpperCase() === 'PF') {
        registerName = register.person?.full_name || registerName;
      } else {
        registerName = register.company?.corporate_name || registerName;
      }
    }

    // Verificar se o usuário está visualizando seu próprio registro
    if (!registerId) {
      return;
    }

    const isSelfView = this.isSelfViewingRegister(registerId);
    const breadcrumbLabel = isSelfView ? 'Meu registro' : 'Cadastros';
    const breadcrumbUrl = isSelfView
      ? `/app/details/${this.role}/${registerId}`
      : '/app/registers';

    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: breadcrumbLabel,
        url: breadcrumbUrl,
        clickable: isSelfView ? false : canViewCadastros,
      },
      {
        label: registerName,
        url: `/app/details/${this.role}/${registerId}`,
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];

    if (this.breadcrumbService) {
      this.breadcrumbService.setBreadcrumbs(breadcrumbs);
    }
  }

  /**
   * Verifica se o usuário está visualizando seu próprio registro
   * (cedente, cotista ou prestador de serviço que não é colaborador comum ou master)
   */
  private isSelfViewingRegister(registerId: string): boolean {
    if (!registerId) {
      return false;
    }

    const user = this.authService?.getUser();
    if (!user || !user.active_register) {
      return false;
    }

    // Verificar se NÃO é colaborador comum ou master
    const isCommonCollaborator =
      this.authService?.isCommonCollaborator() || false;
    const isMaster = this.authService?.isMasterUser() || false;

    if (isCommonCollaborator || isMaster) {
      return false;
    }

    const activeRegister = user.active_register.register;

    // Verificar se o role corresponde ao role do usuário
    const isRoleMatch = activeRegister.role?.applicable === this.role;

    // Verificar se o ID corresponde ao ID do registro ativo do usuário
    const isIdMatch = activeRegister.id === registerId;

    // Verificar se o role é um dos permitidos (cedente, cotista ou prestador)
    const isAllowedRole =
      this.role === 'shareholder' ||
      this.role === 'assignor' ||
      this.role === 'provider';

    return isRoleMatch && isIdMatch && isAllowedRole;
  }

  /**
   * Método removido - não precisa mais chamar API legacy
   * O backend já cria versão 1 automaticamente quando não existe versão 1
   */
  private async checkAndCreateLegacyVersion(): Promise<void> {
    // Não precisa mais fazer nada - o backend já cria versão 1 automaticamente
    this.legacyVersionChecked = true;
  }
}
